/* eslint-disable max-len */
const en = {
  'admin.ADD': 'Add',
  'admin.ADD_NEW_PROMPT': 'Add New Prompt',
  'admin.UPDATE': 'Update',
  'bulkutility.TITLE_BULKACTION': 'Bulk Action Processor',
  'bulkutility.UPLOAD_EXCEL': 'Upload Your SpreadSheet Here',
  'chatUtility.AI_RESPONSE': 'AI Study Tool Response',
  'chatUtility.AUDIT_LOG': 'Audit Logs',
  'chatUtility.HOME': 'Go to ChatGptutilty Home',
  'chatUtility.PROMPT': 'Prompt',
  'effectiveness.RUN_TEST': 'RUN TEST',
  'effectiveness.GET_RESULTS': 'GET RESULTS',
  'chatUtility.PROMPT_MANANGEMENT': 'Prompt Management',
  'chatUtility.SUMMARY_QUIZ_MANANGEMENT': 'Content Management',
  'chatUtility.AIADMIN_USERS': 'Users',
  'chatUtility.INGESTION': 'Ingestion',
  'effectiveness.LLM_EVALUATION': 'LLM Evaluation',
  'chatUtility.REPORTS': 'Reports',
  'chatUtility.TRENDS_INSIGHTS': 'Trends & Insights',
  'chatUtility.USER_FEEDBACK': 'User Feedback',
  'chatUtility.USER_INPUT': 'User Input/Command',
  'common.a11y.LOGO': 'Pearson Logo',
  'common.LOADING': 'Loading...',
  'common.a11y.MORE_ICON': 'More...',
  'common.APPLY': 'Apply',
  'common.BACK': 'Back',
  'common.NEXT': 'Next',
  'common.PREV': 'Previous',
  'common.CANCEL': 'Cancel',
  'common.CLOSE': 'Close',
  'common.COLLAPSE': 'Collapse',
  'common.DELETE': 'Delete',
  'common.EXPAND': 'Expand',
  'common.FAILED': 'Failed',
  'common.GO_TO_DASHBOARD': 'Go to Dashboard',
  'common.HOME': 'Home',
  'common.IN_PROGRESS': 'In Progress',
  'common.LOGOUT': 'Logout',
  'common.NO': 'No',
  'common.OK': 'Ok',
  'common.SAVE': 'Save',
  'common.SEARCH': 'Search',
  'common.EXPORT_CSV': 'Export CSV',
  'aiadmin.EXPORT_LABEL': 'Export',
  'aiadmin.EXPORTING_LABEL': 'Exporting...',
  'aiadmin.EXPORT_CSV_MENU_LABEL': 'CSV',
  'aiadmin.EXPORT_XLSX_MENU_LABEL': 'XLSX',
  'aiadmin.EXPORT_PROPERTIES_LABEL': 'Properties',
  'aiadmin.EXPORT_SELECT_PROPERTY': 'Select at least one property to export',
  'aiadmin.EXPORT_MISSING_ID_BOUNDS': 'Unable to export: missing id bounds from the current search results',
  'aiadmin.EXPORT_MISSING_PATH_PARAMS': 'Unable to export: missing required chart filters from the current search',
  'aiadmin.EXPORT_UNABLE_CSV': 'Unable to export CSV',
  'aiadmin.EXPORT_DOWNLOAD_SUCCESS': '{filename} downloaded successfully',
  'aiadmin.EXPORT_FAILED': 'Export failed',
  'aiadmin.EXPORT_ROW_LIMIT_EXCEEDED': 'Export limited to {limit} rows. Apply filters to reduce the result set.',
  'aiadmin.EXPORT_NETWORK_ERROR': 'Export failed. Please check your network connection and try again.',
  'aiadmin.EXPORT_FAILED_RETRY': 'Export failed. Please try again.',
  'aiadmin.EXPORT_EMPTY_RESPONSE': 'Export failed: empty or invalid file received',
  'aiadmin.EXPORT_CURRENT_PAGE_HINT': 'Exports the current page of search results',
  'aiadmin.EXPORT_XLSX_FOOTER_SINGULAR': 'Export XLSX (1 column)',
  'aiadmin.EXPORT_XLSX_FOOTER_PLURAL': 'Export XLSX ({count} columns)',
  'common.SELECT': 'Select',
  'common.SEND': 'Send',
  'common.SUCCESS': 'Success',
  'common.TRY_LOGIN_AGAIN': 'Try Logging in Again',
  'common.YES': 'Yes',
  'common.NO_RESULT_FOUND': 'No results found',
  'common.METADATA': 'Metadata:',
  'common.PROCESSED_SUMMARY': 'Processed Summary',
  'common.FINAL_SUMMARY': 'Final Summary',
  'common.NO_RESULT_FILTER_DESC': 'Try adjusting your search or filter.',
  'common.COMMENT': 'Comment',
  'common.COMMENT_TOOLTIP': 'Add Comment/Feedback',
  'dashboard.HEADER_TEXT': 'Dashboard',
  'dashboard.USER_MGMT_DESC': 'Manage Users, Roles & permissions',
  'dashboard.USER_MGMT_LABEL': 'User Management',
  'effectiveness.INITIATE_NEW': 'INITIATE NEW',
  'error.HEADER': "Didn't load some information. ",
  'error.HEADER_LINK': 'Please try again',
  'error.NOT_READY_HEADER': "We're setting up your data. Hold tight.",
  'footer.ACCESSIBILITY': 'Accessibility',
  'footer.COPYRIGHT': 'Copyright \u00A9 {year} Pearson Education Inc. All Rights Reserved.',
  'footer.PRIVACY': 'Privacy Policy',
  'footer.TERMS_COND': 'Terms \u0026 Conditions',
  'mcq.ADD': 'Add New Question',
  'mcq.DELETE': 'Delete Question',
  'mcq.EDIT': 'Edit Question',
  'mcq.PUBLISH': 'Publish Question',
  'mcq.UN_PUBLISH': 'Un-Publish Question',
  'mcq.NEXT': 'Next Question',
  'mcq.PREVIOUS': 'Previous Question',
  'mcq.PUBLISHALL': 'Publish All',
  'prompt.PUBLISH': 'Publish Prompt',
  'prompt.HISTORY': 'Prompt History',
  'summary.ADD': 'Add New Summary',
  'summary.DELETE': 'Delete Summary',
  'summary.EDIT': 'Edit Summary',
  'summary.NEXT': 'Next Summary',
  'summary.PREVIOUS': 'Previous Summary',
  'summary.PUBLISH': 'Publish Summary',
  'unauthorized.BODY_TEXT':
    'Your privileges do not let you access this Page. Please contact your Pearson production manager for assistance with requesting access to this application.',
  'unauthorized.TITLE_TEXT': 'Unauthorized Access',
  'user.ADD': 'Add',
  'user.ADD_USER': 'Add User',
  'user.ADMIN_TEXT': 'This role provides Admin access to all the features.',
  'user.CANCEL_ADDING_NEW_USER': 'Cancel Adding New User',
  'user.CANCEL_EDITING_USER': 'Cancel Editing User Details',
  'user.DESC': 'Role Description: ',
  'user.EDIT': 'Edit',
  'user.EDIT_DETAILS': 'Edit User Details',
  'user.ETEXT_PROJECT': 'eText Project',
  'user.FAVORITE': 'Add to Favorite',
  'user.LIST': 'List',
  'user.PERMISSION': 'Permission',
  'user.PERMISSIONS_LABEL': "You don't have required permissions",
  'user.PREVIEW': 'Authoring & Preview',
  'user.REPORTS': 'Reports',
  'user.RESET': 'Reset All Fields',
  'user.ROLENAME': 'Role Name: ',
  'user.ROLES': 'Roles & Permission',
  'user.SAVE_USER_DETAILS': 'Save User Details',
  'user.SIGNOUT': 'Sign Out',
  'user.USERACTION': 'User Edit',
  'user.USERADD': 'User Add',
  'user.USERLIST': 'User List',
  'user.USERS': 'Users',
  'user.USER_MANAGEMENT': 'User Manangement',
  'user.USER_MANAGEMENT_DESC': 'Manage user information',
  'user.USER_MANAGEMENT_LABEL': 'User Management',
  'user.SEARCH_TEXT': 'Search by User Login , Email , First Name or Last Name',
  'user.FILTER_BY_ROLE': 'Role',
  'user.ALL_ROLES': 'All',
  'user.DELETE_USER_CONFIRM_PREFIX': 'Are you sure you want to remove',
  'user.DELETE_USER_CONFIRM_FROM': 'from',
  'user.DELETE_USER_CONFIRM_THIS_TENANT': 'this tenant',
  'user.DELETE_USER_REMOVE_FROM_NAMED_TENANT': 'Remove this user from tenant?',
  'user.DELETE_USER_REMOVE_FROM_THIS_TENANT': 'Remove this user from this tenant?',
  'user.DELETE_USER_CONFIRM_REMOVE': 'Remove',
  'useraction.EMAIL': 'Email',
  'useraction.FIRSTNAME': 'First Name',
  'useraction.LASTNAME': 'Last Name',
  'useraction.ROLE': 'Role',
  'useraction.USERLOGIN': ' User ID',
  'useredit.PERMISSION': 'View Permission',
  'user.FILTER_BY_USER_ID': 'Filter results by this User Id',
  'llmevaluation.NO_DATA_MESSAGE': 'Data not available for selected Test Suite.',
  'evaluationReport.NO_DATA_MESSAGE': 'No scores in this execution.',
  'evaluationReport.TITLE': 'Evaluation Report',
  'consolidatedReport.TITLE': 'Consolidated Report',
  'consolidatedReport.LOADING_MESSAGE': 'Please wait while we load the consolidated report for you.',
  'consolidatedReport.NO_RUNS_MESSAGE': 'No completed evaluation runs match the selected filters.',
  'consolidatedReport.HERO_EYEBROW': 'Evaluation score',
  'consolidatedReport.KPI_EYEBROW': 'KPI · {criterion}',
  'consolidatedReport.KPI_CAPTION': 'Key performance indicator for this rubric.',
  'consolidatedReport.TREND_VS_LAST_RUN': 'vs last run',
  'consolidatedReport.AVG_SCORE': 'Avg score',
  'consolidatedReport.PCT_EXCELLENT': '% excellent',
  'consolidatedReport.PCT_POOR': '% poor',
  'consolidatedReport.DISTRIBUTION_CONVERSATIONS': '{count} conversations',
  'consolidatedReport.DISTRIBUTION_SAMPLED': '{count} sampled',
  'consolidatedReport.SCORE_DISTRIBUTION': 'Score distribution · {count} conversations',
  'consolidatedReport.CRITERION_BREAKDOWN': 'Per-criterion breakdown',
  'consolidatedReport.CRITERION_HINT': 'score / max',
  'consolidatedReport.CONVERSATIONS_TITLE': 'Conversations',
  'consolidatedReport.CONVERSATION_COLUMN': 'Conversation',
  'consolidatedReport.AUDIT_DATE_COLUMN': 'Audit Date (UTC)',
  'consolidatedReport.VERSION_COLUMN': 'Version',
  'consolidatedReport.BAND_LABEL': 'Band',
  'consolidatedReport.SCORE_LABEL': 'Score',
  'consolidatedReport.KPI_SCORE_LABEL': 'KPI score',
  'consolidatedReport.RECENT_RUNS_TITLE': 'Recent runs',
  'consolidatedReport.BACK_TO_REPORT': 'Back to report',
  'consolidatedReport.CRITERION_DEEP_DIVE': 'Trends',
  'consolidatedReport.CRITERION_TREND_TITLE': 'Trend · last {count} runs',
  'consolidatedReport.CRITERION_RUN_SCORE_TITLE': 'Criterion score for this run',
  'consolidatedReport.CRITERION_NOT_IN_RUN': 'This criterion was not evaluated in this run.',
  'consolidatedReport.FULL_REPORT': 'Full Report',
  'consolidatedReport.WINDOW_LABEL': 'Window',
  'consolidatedReport.WINDOW_DAYS_VALUE': '{count}d',
  'consolidatedReport.VERSION_SELECTOR_LABEL': 'Version',
  'consolidatedReport.VERSION_ALL': 'All',
  'consolidatedReport.RECENT_RUN_TREND_TITLE': 'Recent Run Trends · last {count} days',
  'consolidatedReport.TREND_NO_SCORE': 'No score',
  'consolidatedReport.TREND_CLOSE_DAY_DETAILS': 'Close',
  'consolidatedReport.TREND_OPEN_RUN': 'Open in report',
  'consolidatedReport.DOWNLOAD_RUBRIC': 'Rubric',
  'consolidatedReport.RUBRIC_TEXT_TITLE': 'Rubric Text',
  'consolidatedReport.DOWNLOAD_RUBRIC_FILE': 'Download rubric',
  'evaluationReport.LOADING_MESSAGE': 'Please wait while we Generate Consolidated Report for you..',
  'evaluationReport.ERROR_MESSAGE': 'Error in Generating Consolidated Report. Please connect with the Support Team.',
  'evaluationReport.INPUT': 'Input',
  'evaluationReport.OUTPUT': 'Output',
  'evaluationReport.USER_QUESTION': 'User Question',
  'evaluationReport.BOT_ANSWER': 'Bot Answer',
  'evaluationReport.FULL_RUBRIC_DOCUMENT': 'Full Rubric Document',
  'evaluationReport.JUDGE_OUTPUT': 'Judge Output',
  'evaluationReport.TEXT_CONTENT': 'Text Content',
  'evaluationReport.JUDGE_CRITERIA': 'Judge criteria',
  'evaluationReport.CRITERION': 'Criterion',
  'evaluationReport.SCORE': 'Score',
  'evaluationReport.RATIONALE': 'Rationale',
  'evaluationReport.NO_RUBRIC': 'No rubric document available.',
  'evaluationReport.NO_TEXT_CONTENT': 'No text content available.',
  'evaluationReport.KPI_RUNS_LOADED': 'Runs loaded',
  'evaluationReport.KPI_RUNS_LOADED_HINT': 'One bar per API row (sorted by date)',
  'evaluationReport.KPI_TOTAL_SAMPLES': 'Total Samples',
  'evaluationReport.KPI_TOTAL_SAMPLES_HINT': 'All scored samples across runs',
  'evaluationReport.KPI_AVG_GOOD_PER_RUN': 'Average % Good per run',
  'evaluationReport.KPI_AVG_GOOD_PER_RUN_HINT': 'Mean % Good across sampled runs',
  'evaluationReport.KPI_FAILED_RUNS': 'Failed runs',
  'evaluationReport.KPI_FAILED_RUNS_HINT': 'Runs with empty scores[]',
  'evaluationReport.KPI_ITEM_BELOW_GOOD': 'Item Below Good',
  'evaluationReport.KPI_ITEM_BELOW_GOOD_HINT': 'Mixed + Low buckets',
  'evaluationReport.NO_ITEMS': 'No items',
  'evaluationReport.GOOD_ITEMS': 'Good items:',
  'evaluationReport.SAMPLES_COUNT': 'samples.',
  'evaluationReport.NO_SAMPLES_SUFFIX': ' · No samples',
  'evaluationReport.NO_SAMPLES_IN_PARENS': ' (no samples)',
  'evaluationReport.NO_SAMPLES_FOR_RUN': 'No samples for this run.',
  'evaluationReport.NO_SAMPLES_COLON': ': no samples',
  'evaluationReport.CHART_TOOLTIP_WITH_SAMPLES': '{label}: {composite}% good ({sampleCount} samples)',
  'evaluationReport.CHART_SCROLL_HINT': ' · Scroll horizontally for older runs (newest on the left)',
  'evaluationReport.RAG_CONTENT': 'RAG Content',
  'evaluationReport.RUBRIC_TEXT': 'Rubric Text',
  'evaluationReport.BUCKET_INTRO_GOOD': 'Met the Good quality bar across all judge criteria.',
  'evaluationReport.BUCKET_INTRO_MIXED': 'Some judge criteria passed and others did not — quality was inconsistent.',
  'evaluationReport.BUCKET_INTRO_LOW': 'Did not meet the Good quality bar based on judge scores.',
  'evaluationReport.NO_SAMPLES_IN_BUCKET': 'No samples fall into this category for the selected runs.',
  'evaluationReport.DAILY_COMPOSITE_TITLE': 'Daily Composite',
  'evaluationReport.DAILY_COMPOSITE_HINT': 'Each bar uses a 0-100 scale. Hover a bar for % Good and sample count',
  'evaluationReport.LATEST_SAMPLES_TITLE': 'Latest Samples',
  'evaluationReport.NO_RUNS_LOADED': 'No runs loaded.',
  'evaluationReport.LATEST_SAMPLES_CLICK_HINT': '· Click a row for judge detail.',
  'evaluationReport.NO_SAMPLES_FOR_LATEST_RUN': 'No samples for the latest run.',
  'evaluationReport.COMPOSITE_SCORE': 'Composite {score}%',
  'evaluationReport.BUCKET_LABEL': 'Bucket:',
  'evaluationReport.COMPOSITE_LABEL': 'Composite',
  'evaluationReport.EVALUATION_CRITERIA': 'Evaluation Criteria',
  'evaluationReport.RUBRIC_FROM_LATEST_EXECUTION': 'Rubric text from the latest execution',
  'evaluationReport.NO_RUBRIC_IN_LATEST_RUN': 'No rubric content was found in the latest run.',
  'evaluationReport.RUN_ID': 'Run id: {id}',
  'evaluationReport.SAMPLE_LABEL': 'Sample {index}',
  'evaluationReport.RUN_DEFAULT_LABEL': 'Run',
  'evalResult.BACK_TO_LIST_ARIA': 'Back to list',
  'evalResult.PREVIOUS_ROW_ARIA': 'Previous row',
  'evalResult.NEXT_ROW_ARIA': 'Next row',
  'evalResult.CLOSE_ARIA': 'Close',
  'evalResult.LOADING_MESSAGE': 'Loading execution results…',
  'evalResult.ERROR_MESSAGE': 'Could not load this execution. Try again or contact support.',
  'evalResult.LIST_LOADING_MESSAGE': 'Loading evaluation runs…',
  'evalResult.LIST_ERROR_MESSAGE': 'Could not load evaluation runs. Try again or contact support.',
  'evalResult.CONVERSATION_COLUMN': 'Conversation',
  'evalResult.TURNS_SUBTITLE': '{count} turns',
  'evalResult.TRANSCRIPT_HEADER': 'Conversation transcript — scores apply to full conversation, not individual turns',
  'evalResult.TURN_INPUT_LABEL': 'Turn {number} · Input',
  'evalResult.OUTPUT_LABEL': 'Output',
  'evaluationSearch.RUBRIC_NAME_MIN_LENGTH_ERROR': 'Enter at least 3 characters to search by rubric name.',
  'evaluationSearch.CONSOLIDATED_REPORT_REQUIRES_GRAPH': 'Select a graph to view consolidated report.',
  'evaluationSearch.LIST_SEARCH_REQUIRES_GRAPH_OR_RUBRIC':
    'Select a graph or enter at least 3 characters in Rubric Name to search.',
  'evalBatchReport.TITLE': 'Batch Report',
  'evalBatchReport.LOADING_MESSAGE': 'Loading batch report…',
  'evalBatchReport.ERROR_MESSAGE': 'Could not load batch report. Try again or contact support.',
  'evalBatchReport.EVAL_NAME': 'Graph',
  'evalBatchReport.RUBRIC': 'Rubric',
  'evalBatchReport.OVERALL_STATUS': 'Overall Status',
  'evalBatchReport.CREATED_DATE': 'Execution Started',
  'evalBatchReport.COMPLETED_DATE': 'Execution Completed',
  'evalBatchReport.BATCH_NAME': 'Batch Name',
  'evalBatchReport.COUNT': 'Total Count',
  'evalBatchReport.PROCESSED_COUNT': 'Processed Count',
  'evalBatchReport.FAILED_COUNT': 'Failed Count',
  'evalBatchReport.STATUS': 'Status',
  'evalBatchReport.NO_BATCHES_MESSAGE': 'No batch records found for this execution.',
  'evalBatchReport.FAILED_IDS_TITLE': 'Failed Records',
  'evalBatchReport.REQUEST_ID': 'Request Id',
  'evalBatchReport.ERROR': 'Error',
  'evalBatchReport.NO_FAILED_IDS_MESSAGE': 'No failed record details available.',
  'evalBatchReport.VIEW_FAILED_IDS_ARIA': 'View failed record details',
  // Text Content Modal
  'textContent.MODAL_TITLE': 'Page Text Content',
  'textContent.DECODE_TOOLTIP': 'Decode Base64 XPath',
  'textContent.CLOSE_TOOLTIP': 'Close',
  'textContent.LOADING': 'Loading text content...',
  'textContent.NO_DATA': 'No text content available',
  'textContent.DECODE_SUCCESS': 'Successfully decoded',
  'textContent.DECODE_XPATH': 'Base64 XPath',
  'textContent.DECODE_XPATHS': 'Base64 XPaths',
  'textContent.NO_XPATH_FOUND': 'No Base64 XPath patterns found to decode',
  'textContent.DECODE_ERROR': 'Error decoding Base64 XPath',
  'textContent.VIEW_TOOLTIP': 'View Text Content',
  'textContent.FAILED': 'Failed to load text content.',
  'textContent.MISSING_BOOK_PAGE': 'Missing bookId or pageId',
  'textContent.MISSING_TENANT': 'Missing tenantId',
  // AET Quiz View
  'aetQuiz.LABEL_JSON': 'JSON',
  'aetQuiz.NO_RAW_DATA': 'No raw data available',
  'aetQuiz.LABEL_TOPIC': 'Topic',
  'aetQuiz.LABEL_QUESTION': 'Question',
  'aetQuiz.CORRECT_BADGE': '✓ Correct',
  'aetQuiz.INCORRECT_BADGE': '✗ Incorrect',
  'aetQuiz.MISCONCEPTION_TAG': 'Misconception Tag',
  'aetQuiz.EXPLANATION': 'Explanation',
  'aetQuiz.CORRECTIVE_FEEDBACK': 'Corrective Feedback',
  'aetQuiz.DISABLED_RAW_MODE': 'Disabled in Raw Data mode',
  'aetQuiz.WARNING_TITLE': 'Question rendering issue',
  'aetQuiz.WARNING_MESSAGE': 'The question cannot be displayed due to invalid or missing data.',
  // AET Quiz Edit Dialog Constants
  'aetQuizEdit.UPDATE_QUESTION': 'Update your question here',
  'aetQuizEdit.UPDATE_OPTION': 'Update your option here',
  'aetQuizEdit.UPDATE_MISCONCEPTION': 'Update misconception tag here',
  'aetQuizEdit.UPDATE_EXPLANATION': 'Update explanation here',
  'aetQuizEdit.UPDATE_CORRECTIVE': 'Update corrective feedback here (for incorrect answers)',
  'aetQuizEdit.CORRECT_CHOICE': 'Correct Choice',
  'aetQuizEdit.ADD_OPTION_TOOLTIP': 'This will add a new option block. MAX limit: 4',
  // Graph Editor Constants
  'graphEditor.ADD_EVALUATION': 'Evaluation',
  'graphEvaluation.PANEL_TITLE': 'Evaluations',
  'graphEvaluation.DETAIL_PANEL_TITLE': 'Evaluation',
  'graphEvaluation.CLOSE_PANEL': 'Close evaluation panel',
  'graphEvaluation.RUBRIC_NAME_LABEL': 'Rubric Name',
  'graphEvaluation.RUBRIC_NAME_PLACEHOLDER': 'Enter rubric name',
  'graphEvaluation.ADD_EVALUATION': 'Add evaluation',
  'graphEvaluation.ADD_EVALUATION_ARIA': 'Add new evaluation',
  'graphEvaluation.EDIT_EVALUATION_ARIA': 'Edit evaluation',
  'graphEvaluation.DELETE_EVALUATION_ARIA': 'Delete evaluation',
  'graphEvaluation.BACK_TO_LIST': 'Back to evaluations list',
  'graphEvaluation.LIST_EMPTY_TITLE': 'No evaluations yet',
  'graphEvaluation.LIST_EMPTY_BODY': 'Add an evaluation to define rubric text and schedule batch runs.',
  'graphEvaluation.LIST_NOT_SCHEDULED': 'Not scheduled',
  'graphEvaluation.LIST_SCHEDULED': 'Scheduled',
  'graphEvaluation.LIST_SCHEDULE_AT': 'Scheduled at {time}',
  'graphEvaluation.LIST_DAILY_BADGE': 'Daily',
  'graphEvaluation.LIST_ONE_TIME_BADGE': 'One Time',
  'graphEvaluation.LIST_CONVERSATIONAL_BADGE': 'Conversational',
  'graphEvaluation.LIST_TRANSACTIONAL_BADGE': 'Transactional',
  'graphEvaluation.LIST_SAMPLE_PERCENT': '{percent}% sample',
  'graphEvaluation.LIST_TYPES_NONE': 'No types',
  'graphEvaluation.LIST_TYPES_COUNT': '{count} types',
  'graphEvaluation.LIST_LOADING': 'Loading evaluations…',
  'graphEvaluation.FETCH_LIST_RETRY': 'Failed to load evaluations. Please try again.',
  'graphEvaluation.FETCH_DETAIL_RETRY': 'Failed to load evaluation details. Please try again.',
  'graphEvaluation.DELETE_SUCCESS': 'Evaluation deleted successfully.',
  'graphEvaluation.DELETE_RETRY': 'Failed to delete evaluation. Please try again.',
  'graphEvaluation.CONFIRM_DISCARD_TITLE': 'Discard changes?',
  'graphEvaluation.CONFIRM_DISCARD_BODY': 'You have unsaved changes. Discard them and leave this evaluation?',
  'graphEvaluation.CONFIRM_DISCARD_CONFIRM': 'Discard',
  'graphEvaluation.CONFIRM_DELETE_TITLE': 'Delete evaluation?',
  'graphEvaluation.CONFIRM_DELETE_BODY': 'Delete "{name}"? Scheduled runs will also stop for this.',
  'graphEvaluation.CONFIRM_DELETE_HINT': 'This applies to all versions using this rubric.',
  'graphEvaluation.CONFIRM_DELETE_CONFIRM': 'Delete',
  'graphEvaluation.CONFIRM_CANCEL': 'Cancel',
  'graphEvaluation.SAVE_TOOLTIP_MISSING_RUBRIC_NAME': 'Enter a rubric name.',
  'graphEvaluation.VIEW_EVALUATION_ARIA': 'View evaluation',
  'graphEvaluation.SAMPLE_PERCENT': 'Sample %',
  'graphEvaluation.SAMPLE_PERCENT_PLACEHOLDER': '0–100',
  'graphEvaluation.DATE_TIME_LOCAL': 'Date & Time',
  'graphEvaluation.HOUR': 'Hour',
  'graphEvaluation.MINUTE': 'Minute',
  'graphEvaluation.SCHEDULE_MODAL_TITLE': 'Select Date & Time',
  'graphEvaluation.DATE_TIME_PLACEHOLDER': 'Select date & time',
  'graphEvaluation.PAST_DATE_ERROR': 'Past dates cannot be selected.',
  'graphEvaluation.CURRENT_OR_FUTURE_DATETIME_ERROR': 'Select a current or future date & time to run evaluation.',
  'graphEvaluation.SCHEDULE': 'Schedule',
  'graphEvaluation.SAVE': 'Save',
  'graphEvaluation.ENHANCE': 'Enhance',
  'graphEvaluation.ENHANCE_ERROR': 'Failed to enhance evaluation rubric. Please try again.',
  'graphEvaluation.SAVE_TOOLTIP_NOT_DIRTY': 'No changes to save.',
  'graphEvaluation.SAVE_TOOLTIP_ENHANCE_REVIEW': 'Finish reviewing enhanced rubric first.',
  'graphEvaluation.DIFF_MODAL_TITLE': 'Review enhanced rubric',
  'graphEvaluation.DIFF_CURRENT_LABEL': 'Current rubric',
  'graphEvaluation.DIFF_IMPROVED_LABEL': 'Enhanced rubric',
  'graphEvaluation.DIFF_DISCARD': 'Discard',
  'graphEvaluation.DIFF_SAVE': 'Save',
  'graphEvaluation.SCHEDULE_TOOLTIP_SELECT_DATETIME': 'Select date and time.',
  'graphEvaluation.SCHEDULE_TOOLTIP_MISSING_SAMPLE': 'Missing sample %.',
  'graphEvaluation.SCHEDULE_TOOLTIP_MISSING_CRITERIA': 'Missing evaluation criteria.',
  'graphEvaluation.SCHEDULE_TOOLTIP_SELECT_FUTURE_DATETIME': 'Select a current or future date & time.',
  'graphEvaluation.REPEAT_DAILY': 'Repeat daily',
  'graphEvaluation.REPEAT_DAILY_HELPER': 'When enabled, the evaluation runs every day at the selected time.',
  'graphEvaluation.CONVERSATIONAL': 'Conversational',
  'graphEvaluation.CRITERIA_LABEL': 'Specify your Rubric Text here (Markdown)',
  'graphEvaluation.CRITERIA_PLACEHOLDER': 'Paste your evaluation rubric in Markdown...',
  'graphEvaluation.SCHEDULE_TOOLTIP_SAVE_RUBRIC_FIRST': 'Save rubric text before scheduling.',
  'graphEvaluation.SAVE_TOOLTIP_MISSING_RUBRIC_TEXT': 'Enter evaluation rubric text.',
  'graphEvaluation.TYPES_LABEL': 'Types',
  'graphEvaluation.SELECT_TYPES': 'Select Types',
  'graphEvaluation.ALL_TYPES': 'All Types',
  'graphEvaluation.TYPES_SELECTED': '{count} types selected',
  'graphEvaluation.TYPES_PLACEHOLDER': 'Select types',
  'graphEvaluation.SAVE_TOOLTIP_MISSING_EVAL_TYPES': 'Select at least one evaluation type.',
  'graphEvaluation.SAVE_RUBRIC_TEXT_SUCCESS': 'Evaluation Rubric Text Saved Successfully',
  'graphEvaluation.SAVE_RUBRIC_TEXT_ERROR_PREFIX': 'Failed to save evaluation rubric text',
  'graphEvaluation.SAVE_RUBRIC_TEXT_RETRY': 'Failed to save evaluation rubric text. Please try again.',
  'graphEvaluation.SAVE_SCHEDULER_SUCCESS': 'Success. To check progress, go to Evaluation Report.',
  'graphEvaluation.SAVE_SCHEDULER_ERROR_PREFIX': 'Failed to save evaluation schedule',
  'graphEvaluation.SAVE_SCHEDULER_RETRY': 'Failed to save evaluation schedule. Please try again.',
  'graphEvaluation.MISSING_TENANT':
    'Missing tenant id for Eval Lens. Pass tenantId from the app (x-berlin-tenant-id header).',
  'graphEvaluation.MISSING_RUBRIC': 'Missing rubric id for Eval Lens.',
  'graphEvaluation.INVALID_RESPONSE': 'Invalid Eval Lens response',
  'graphEvaluation.RUN_FAILED': 'Eval Lens evaluation failed',
  'graphEvaluation.FETCH_CRITERIA_FAILED': 'Failed to fetch evaluation criteria. Please try again.',
  'graphEvaluation.MISSING_REQUEST_ID': 'Missing request id for Eval Lens evaluation.',
  'graphEditor.TEST_GRAPH': 'Test Graph',
  'graphEditor.DOWNLOAD_CURL': 'Download Curl',
  'graphEditor.ADVANCE_MODE': 'Advance Mode',
  'graphEditor.BACK_TO_GRAPH_EDITOR': 'Back to Graph Editor',
  'advanceStudio.CONNECT_GRAPH_HINT': 'Connect a graph in the sidebar',
  'advanceStudio.UNNAMED_GRAPH': 'Unnamed graph',
  'advanceStudio.GRAPH_NAME_SUFFIX': 'Graph · …{tail}',
  'advanceStudio.THIS_GRAPH': 'this graph',
  'advanceStudio.ACTIVE_BADGE': 'active',
  'advanceStudio.CONNECT_GRAPH_SIDEBAR': 'Use <strong>Load Graph</strong> to connect a graph.',
  'advanceStudio.SETUP': 'Setup',
  'advanceStudio.PARSED_CONFIG': 'Parsed config',
  'advanceStudio.GRAPH_NAME': 'Graph name',
  'advanceStudio.GRAPH_ID': 'Graph ID',
  'advanceStudio.GRAPH_VERSION': 'Graph version',
  'advanceStudio.TENANT_ID': 'Tenant ID',
  'advanceStudio.TENANT_KEY': 'Tenant Key',
  'advanceStudio.BASE_URL': 'Base URL',
  'advanceStudio.RESET_RUN_DATA': "Reset this graph's run data",
  'advanceStudio.AGENTS': 'Agents',
  'advanceStudio.TOOLS': 'Tools',
  'advanceStudio.SETUP_FETCHING_TOKEN': 'Fetching IES token…',
  'advanceStudio.SETUP_TOKEN_UNAVAILABLE': 'IES token unavailable',
  'advanceStudio.SETUP_GRAPH_LOADED': 'Graph loaded — IES token ready',
  'advanceStudio.SETUP_TOKEN_READY': 'IES token ready',
  'advanceStudio.BERLIN_TOPBAR': 'Berlin',
  'advanceStudio.CONNECTED': 'connected',
  'advanceStudio.DISCONNECTED': 'disconnected',
  'advanceStudio.RUNS': 'runs',
  'advanceStudio.RUNNING': 'running…',
  'advanceStudio.RUN_GRAPH': 'run graph',
  'advanceStudio.TAB_PROMPT': 'Prompt',
  'advanceStudio.TAB_RESPONSE': 'Response',
  'advanceStudio.TAB_INPUT': 'Input',
  'advanceStudio.TAB_IMPLEMENTATION': 'Implementation',
  'advanceStudio.TOOL_IMPLEMENTATION': 'implementation ·',
  'advanceStudio.TOOL_PROMPT': 'tool prompt ·',
  'advanceStudio.TOOL_INPUT': 'tool input ·',
  'advanceStudio.TOOL_RESPONSE': 'tool response ·',
  'advanceStudio.NO_TOOL_IMPLEMENTATION': 'No implementation defined for this tool in the graph.',
  'advanceStudio.SELECT_TOOL_FOR_IMPLEMENTATION': 'Select a tool from the sidebar to view its implementation.',
  'advanceStudio.NO_TOOL_PROMPT': 'No prompt or description for this tool.',
  'advanceStudio.NO_TOOL_INPUT': 'Run the graph to capture tool input for this call.',
  'advanceStudio.NO_TOOL_RESPONSE': 'Run the graph to capture tool output for this call.',
  'advanceStudio.INVOKED_BADGE': 'invoked',
  'advanceStudio.NO_CATALOG_AGENTS': 'No agents defined on this graph.',
  'advanceStudio.NO_CATALOG_TOOLS': 'No tools defined on this graph.',
  'advanceStudio.SYSTEM_PROMPT': 'system prompt ·',
  'advanceStudio.SAVE': 'save',
  'advanceStudio.EXPAND': 'expand',
  'advanceStudio.PROMPT_PLACEHOLDER':
    'Optional local notes per agent — prompts and tools are configured in Berlin Studio.',
  'advanceStudio.RUN_HISTORY': 'Run history',
  'advanceStudio.EXPORT_JSONL': 'export JSONL',
  'advanceStudio.EXPORT_JSONL_TITLE': 'Download all saved runs as JSONL',
  'advanceStudio.CLEAR': 'clear',
  'advanceStudio.CLEAR_RUN_TITLE': 'Remove the selected run from history',
  'advanceStudio.RUN_HISTORY_EMPTY': 'Runs are saved here after each test (input, response, prompt snapshot).',
  'advanceStudio.NO_RESPONSE': '(no response)',
  'advanceStudio.NO_SSE': 'no SSE',
  'advanceStudio.NO_SSE_TITLE': 'SSE not stored for this run',
  'advanceStudio.NEW_THREAD': 'new thread',
  'advanceStudio.INPUT_LABEL': 'Input',
  'advanceStudio.RESPONSE_LABEL': 'Response',
  'advanceStudio.IN_PREVIEW': 'in:',
  'advanceStudio.OUT_PREVIEW': 'out:',
  'advanceStudio.INPUT_PLACEHOLDER': '{"input": "your test message"}',
  'advanceStudio.SAVE_SAMPLE': 'save sample',
  'advanceStudio.LOAD_SAMPLE': 'load sample',
  'advanceStudio.MOCK_INPUT': 'mock input',
  'advanceStudio.NOT_IMPLEMENTED': 'Not implemented',
  'advanceStudio.NEW_THREAD_CHECKBOX': 'new thread',
  'advanceStudio.RESIZE_LOG': 'Drag to resize log',
  'advanceStudio.RESIZE': 'Drag to resize',
  'advanceStudio.RESET': 'reset',
  'advanceStudio.NEW_CHAT': 'New chat',
  'advanceStudio.CLEAR_CHAT': 'Clear chat',
  'advanceStudio.CHAT_TITLE': 'AI chat',
  'advanceStudio.CHAT_ROLE_USER': 'You',
  'advanceStudio.CHAT_ROLE_AI': 'AI',
  'advanceStudio.CHAT_ROLE_ERROR': 'Error',
  'advanceStudio.CHAT_PLACEHOLDER': 'Ask about this run, edit the prompt, or draft from scratch…',
  'advanceStudio.CHAT_THINKING': 'Thinking…',
  'advanceStudio.CHAT_WELCOME': 'Ask about this run, logs, or agent notes. Local notes only.',
  'advanceStudio.CHAT_ERROR': 'Something went wrong. Please try again.',
  'advanceStudio.CHAT_GRAPH_NOT_FOUND':
    'No LIVE default Advanced Mode chat template found. Contact your administrator.',
  'advanceStudio.SEND': 'send',
  'advanceStudio.RUN_TO_SEE_RESPONSE': 'Run the graph to see the response.',
  'advanceStudio.NO_TEXT': '(no text)',
  'advanceStudio.PROMPT_EDITOR': 'Prompt editor —',
  'advanceStudio.CLOSE': 'Close',
  'advanceStudio.PROMPT_TEXT_PLACEHOLDER': 'Prompt text…',
  'advanceStudio.VERSION_HISTORY': 'Version history',
  'advanceStudio.NO_VERSIONS': 'No versions saved yet.',
  'advanceStudio.RESTORE': 'restore',
  'advanceStudio.SAVE_VERSION': 'save version',
  'advanceStudio.DONE': 'Done',
  'advanceStudio.EXEC_LOG_TITLE': 'Execution log',
  'advanceStudio.EXEC_LOG_TITLE_TIP': 'Step summary only — open SSE stream below for raw events',
  'advanceStudio.EXEC_LOG_STATS': '{steps} steps · {status} status · {chunks} chunks',
  'advanceStudio.EXEC_LOG_WAITING': 'Waiting…',
  'advanceStudio.EXEC_LOG_EMPTY':
    'Run steps appear here (LLM and tool markers). Open SSE stream below for raw event JSON.',
  'advanceStudio.TRACING_REQUIRES_RUN': 'Run the graph to enable tracing',
  'advanceStudio.RESIZE_EXEC_LOG': 'Drag to resize execution log and Raw SSE',
  'advanceStudio.SSE_STREAM': 'SSE stream',
  'advanceStudio.VIEW': 'View',
  'advanceStudio.MODE_DEBUG': 'Debug',
  'advanceStudio.MODE_READABLE': 'Readable',
  'advanceStudio.MODE_LITERAL': 'Literal',
  'advanceStudio.COPY_WIRE': 'copy wire',
  'advanceStudio.COPY_WIRE_TITLE': 'Copy full wire stream including every chunk line',
  'advanceStudio.OUTCOME_OK': 'ok',
  'advanceStudio.OUTCOME_FAIL': 'fail',
  'advanceStudio.TOAST_SELECT_AGENT': 'Select an agent first',
  'advanceStudio.TOAST_PROMPT_SAVED': 'Prompt saved',
  'advanceStudio.TOAST_SAVED_VERSION': 'Saved version {n}',
  'advanceStudio.TOAST_RESTORED_VERSION': 'Restored v{n}',
  'advanceStudio.TOAST_SAMPLE_SAVED': 'Sample input saved',
  'advanceStudio.TOAST_LOADED_SAMPLE': 'Loaded sample input',
  'advanceStudio.TOAST_NO_SAVED_SAMPLE': 'No saved sample',
  'advanceStudio.TOAST_SELECT_GRAPH': 'Select a graph first',
  'advanceStudio.RESET_CONFIRM':
    'Reset all run data for "{label}"?\n\nClears agents, tools, run history, and logs for this graph only. Sample input is kept.',
  'advanceStudio.TOAST_RUN_DATA_RESET': 'Run data reset for {label}',
  'advanceStudio.TOAST_SELECT_OR_ADD_GRAPH': 'Select or add a graph first',
  'advanceStudio.TOAST_TENANT_REQUIRED': 'Tenant ID is required',
  'advanceStudio.TOAST_VERSION_REQUIRED': 'Graph version is required',
  'advanceStudio.TOAST_NO_RESPONSE_BODY': 'No response body',
  'advanceStudio.TOAST_RUN_COMPLETE': 'Run complete',
  'advanceStudio.TOAST_RUN_FAILED': 'Run failed',
  'advanceStudio.TOAST_RUN_NOT_FOUND': 'Run not found',
  'advanceStudio.TOAST_LOADED_RUN': 'Loaded run from history',
  'advanceStudio.TOAST_LOADED_TIMELINE_ONLY': 'Loaded run — timeline only',
  'advanceStudio.TOAST_NO_RUN_SELECTED': 'No run selected',
  'advanceStudio.TOAST_RUN_REMOVED': 'Run removed',
  'advanceStudio.TOAST_NO_RUNS_EXPORT': 'No runs to export',
  'advanceStudio.TOAST_EXPORTED_JSONL': 'Exported JSONL',
  'advanceStudio.RAW_SSE_NO_CAPTURE': 'No SSE captured for this view.',
  'advanceStudio.RAW_SSE_RUN_AGAIN': '• Run the graph again to capture a new stream.',
  'advanceStudio.RAW_SSE_OLDER_RUNS': '• Older runs may show timeline only if browser storage dropped SSE.',
  'advanceStudio.RAW_SSE_CHUNK_ABOUT':
    'About chunk lines: Berlin streams the reply as many small `type:"chunk"` events',
  'advanceStudio.RAW_SSE_CHUNK_EXAMPLE':
    '(e.g. content "orr" then "ect or"). That is normal token streaming, not corruption.',
  'advanceStudio.RAW_SSE_USE_DEBUG': 'Use Debug or Readable view — not Literal — to diagnose runs.',
  'advanceStudio.UNSCOPED_CHUNKS': '(unscoped chunks)',
  'graphEditor.INVALID_GRAPH_DATA': 'Invalid graph data received',
  'graphEditor.PROCESSING': 'Processing...',
  'graphEditor.LOADING_GRAPH': 'Loading graph...',
  'templateGraph.NEW_GRAPH_TITLE': 'Create New Graph',
  'templateGraph.NEW_GRAPH_DESCRIPTION': 'Choose how you want to start your new graph.',
  'templateGraph.BLANK_GRAPH': 'Blank Graph',
  'templateGraph.CREATE_FROM_TEMPLATE': 'Create from Template',
  'templateGraph.LOAD_PATTERN': 'Load Pattern',
  'templateGraph.LOAD_TEMPLATE': 'Load Template',
  'templateGraph.NEW_TEMPLATE': 'New Template',
  'templateGraph.TEMPLATE_NAME_LABEL': 'Template name',
  'templateGraph.TEMPLATE_NAME_TITLE': 'Template Name',
  'templateGraph.TEMPLATE_NAME_PROMPT': 'Please enter a name for your template:',
  'templateGraph.TEMPLATE_NAME_PLACEHOLDER': 'Enter template name',
  'templateGraph.OK_BUTTON': 'OK',
  'templateGraph.SAVE_TEMPLATE': 'Save Template',
  'templateGraph.TEMPLATE_SAVED': 'Template saved successfully.',
  'templateGraph.APPLYING_TEMPLATE': 'Applying Template...',
  'templateGraph.ALL_PATTERNS': 'All patterns',
  'templateGraph.ALL_TEMPLATES': 'All templates',
  'templateGraph.SEARCH_PLACEHOLDER': 'Search all templates...',
  'templateGraph.USE': 'Use',
  'templateGraph.USE_TEMPLATE': 'Use template',
  'templateGraph.PREVIEW': 'Preview',
  'templateGraph.PREVIEW_IMAGE_PLACEHOLDER': 'Template preview image will appear here.',
  'templateGraph.FILTER_FOR_YOU': 'For you',
  'templateGraph.FILTER_ALL': 'All templates',
  'templateGraph.FILTER_CREATED_BY_YOU': 'Created by you',
  'templateGraph.INVALID_ROUTER_CONNECTION':
    'Router pattern only allows classifier -> routerSubagent and routerSubagent -> synthesizer connections.',
  'templateGraph.SKILL_NOT_ALLOWED': 'Skill node is not allowed for the selected pattern.',
  'templateGraph.AGENT_TYPE_NOT_ALLOWED': 'Selected agent type is not allowed for this pattern.',
  'graphEditor.CREATING_GRAPH': 'Creating graph...',
  'graphEditor.SAVING_GRAPH': 'Saving graph...',
  'graphEditor.CREATING_NEW_VERSION': 'Creating new version...',
  'graphEditor.PUBLISHING_NEW_VERSION': 'Publishing new version...',
  'graphEditor.PUBLISHING_GRAPH': 'Publishing graph...',
  'graphEditor.COPYING_GRAPH': 'Copying graph...',
  'graphEditor.SELECT_NODE_TO_CONFIGURE': 'Please select a node to configure',
  'graphEditor.CANNOT_CONFIGURE_NODE': 'Cannot configure {nodeType} node',
  'graphEditor.NEW_GRAPH_CREATED': 'New agent graph created. Start adding your nodes.',
  'graphEditor.BUILD_WITH_BERLIN': 'Build With Berlin',
  'graphEditor.BUILD_WITH_BERLIN_SUBTITLE': 'Create your Agents or graph by describing what you want in plain English.',
  'graphEditor.BERLIN_CHAT_PLACEHOLDER':
    'Describe the agent or workflow you want—goals, tone, audience, and any tools or constraints...',
  'graphEditor.BERLIN_ADD_HINT':
    'Send adds this text to the Prompt editor on the right, then clears here so you can add your next instruction.',
  'graphEditor.BERLIN_SEND': 'Send',
  'graphEditor.PROMPT_EDITOR': 'Graph Builder',
  'graphEditor.PROMPT_EDITOR_HINT':
    'Combined agent instructions for this graph. Append from Build With Berlin with Send, or edit here directly.',
  'graphEditor.PROMPT_EDITOR_PLACEHOLDER': 'Full specification; Sends append.',
  'graphEditor.BERLIN_OPEN_CANVAS': 'Build Graph Workflow',

  'graphEditor.BERLIN_PIPELINE_STEPS_ARIA': 'Pipeline build steps',
  'graphEditor.BERLIN_AI_CHAT_ASSEMBLING': 'Building behind the scenes',

  'graphEditor.BERLIN_BUILD_NEED_TENANT': 'Select a tenant before building.',
  'graphEditor.BERLIN_BUILD_PROCESSING': 'Building graph with Berlin…',
  'graphEditor.BERLIN_BUILD_NO_OUTPUT': 'No graph output received from the generator.',
  'graphEditor.BERLIN_BUILD_AGENT_PROMPT_EMPTY': 'No prompt text returned for this agent.',
  'graphEditor.BERLIN_BUILD_AGENT_GENERATOR_NOT_FOUND':
    'No LIVE default Agent Generator template found. Contact your administrator.',
  'graphEditor.BERLIN_BUILD_AGENT_PROMPT_NOT_FOUND':
    'No LIVE default Prompt Generator template found. Contact your administrator.',
  'graphEditor.BERLIN_BUILD_FAILED': 'Berlin graph build failed.',

  'graphEditor.BERLIN_BUILD_STATUS_1': `Step 1: Plan Agents

It identifies: concept explainer, quiz generator, feedback tutor`,
  'graphEditor.BERLIN_BUILD_STATUS_2': `Step 2: Setting Up Agents

It configures roles, models—and even detects I need external content`,
  'graphEditor.BERLIN_BUILD_STATUS_3': `Step 3: MCP Integration

It connects to the Study Prep MCP server,
tests the connection, and discovers available tool calls—like fetch topic videos`,
  'graphEditor.BERLIN_BUILD_STATUS_4': `Step 4: Write Prompts

It generates production-ready prompts using best practices, incorporating MCP tools for richer responses`,
  'graphEditor.BERLIN_BUILD_STATUS_PREPARING': 'Getting things ready',

  'vibeflow.STEP_YOUR_REQUEST': 'Step {step}: Your request',
  'vibeflow.STEP_CAPTURED_GOAL': 'Captured goal: {goal}',
  'vibeflow.STEP_LAYOUT_GENERATED': 'Step {step}: Graph layout generated',
  'vibeflow.AGENTS_LABEL': 'Agents',
  'vibeflow.TOOLS_LABEL': 'Tools',
  'vibeflow.NONE': 'None.',
  'vibeflow.STEP_CONFIGURE_AGENT': 'Step {step}: Configure {agent}{intent}',
  'vibeflow.STEP_CONFIGURE_AGENTS_BATCH': 'Configuring agents {completed}/{total}',
  'vibeflow.STEP_PROMPT_FROM': 'Generated production prompt from: {desc}',
  'vibeflow.STEP_READY': 'Step {step}: Ready',
  'vibeflow.STEP_READY_BODY': 'Graph assembled — open **Build Graph Workflow** to edit on the canvas.',
  'vibeflow.THOUGHT_PLANNING': 'Planning next move…',
  'vibeflow.THOUGHT_ANALYZING': 'Analyzing your request…',
  'vibeflow.THOUGHT_LAYOUT': 'Graph layout generated — mapping agents and tools…',
  'vibeflow.THOUGHT_WRITING_PROMPTS': 'Writing production prompts ({completed}/{total})…',
  'vibeflow.THOUGHT_ASSEMBLING': 'Assembling graph for the canvas…',
  'vibeflow.THOUGHT_LOG_ARIA': 'Build activity log',

  'graphEditor.NEW_TEMPLATE_APPLIED': 'Template applied. Start adding your nodes.',
  'graphEditor.NODE_ALREADY_EXISTS': '{nodeType} node already exists.',
  'graphEditor.SUPERVISOR_NODE_NOT_ALLOWED':
    'Supervisor nodes are no longer supported for new graphs. Existing supervisor nodes can still be viewed and edited.',
  'flow.ENTER_FULLSCREEN': 'Enter Fullscreen',
  'flow.EXIT_FULLSCREEN': 'Exit Fullscreen',
  'flow.DELETE_SELECTED': 'Delete Selected',
  'flow.EDGE_LABEL_CONDITION': 'condition',
  'flow.EDGE_LABEL_CONTINUE': 'continue',

  // Markdown + MathJax Editor (Studio)
  'markdownMathJax.editorTitle': 'Editor (Markdown + MathJax)',
  'markdownMathJax.previewTitle': 'Preview',
  'markdownMathJax.searchTooltipOpen': 'Search in editor',
  'markdownMathJax.searchTooltipClose': 'Close search',
  'markdownMathJax.searchAriaOpen': 'Open search',
  'markdownMathJax.searchAriaClose': 'Close search',
  'markdownMathJax.searchPlaceholder': 'Find in editor...',
  'markdownMathJax.searchQueryAriaLabel': 'Search query',
  'markdownMathJax.prevMatchTitle': 'Previous match (Shift+Enter or Up Arrow)',
  'markdownMathJax.nextMatchTitle': 'Next match (Enter or Down Arrow)',
  'markdownMathJax.prevMatchAriaLabel': 'Go to previous match',
  'markdownMathJax.nextMatchAriaLabel': 'Go to next match',
  'markdownMathJax.textareaAriaLabel': 'Markdown editor with MathJax support',
  'markdownMathJax.editorPlaceholder': 'Write Markdown. Use $...$ or $$...$$ (or \\\\( \\\\) / \\\\[ \\\\]) for math.',
  'markdownMathJax.iconArrowUp': '↑',
  'markdownMathJax.iconArrowDown': '↓',
  'markdownMathJax.PROMPT_GENERATOR': 'Prompt Generator',
  'markdownMathJax.PROMPT_GENERATOR_TITLE': 'Improve',
  'markdownMathJax.GENERATING': 'Generating',
  'markdownMathJax.systemPromptPlaceholder': 'Start writing your prompt or use AI-powered Prompt Generator!',

  'promptGeneration.TITLE': 'Improve Prompt',
  'promptGeneration.OPEN_TOOLTIP': 'Open Improve Prompt panel',
  'promptGeneration.CLOSE_ARIA': 'Close Improve Prompt panel',
  'promptGeneration.HELPER_TEXT':
    "Paste a question you asked, describe how the AI responded, and say what you'd change — we'll use this to improve the prompt.",
  'promptGeneration.EXAMPLES_PREFIX': 'examples:',
  'promptGeneration.EXAMPLE_TOO_ADVANCED': 'too advanced',
  'promptGeneration.EXAMPLE_NO_COMPREHENSION_CHECK': 'no comprehension check',
  'promptGeneration.EXAMPLE_WRONG_DIFFICULTY': 'wrong difficulty',
  'promptGeneration.EXAMPLE_MISSED_OBJECTIVE': 'missed objective',
  'promptGeneration.EXAMPLE_TOO_ADVANCED_QUESTION': 'What causes waves in the ocean?',
  'promptGeneration.EXAMPLE_TOO_ADVANCED_RESPONSE': "The AI used university-level science terms I don't understand",
  'promptGeneration.EXAMPLE_TOO_ADVANCED_FEEDBACK': "I'm in Grade 6 — use simple words and a real-life comparison",
  'promptGeneration.EXAMPLE_NO_COMPREHENSION_CHECK_QUESTION': "What's the difference between mitosis and meiosis?",
  'promptGeneration.EXAMPLE_NO_COMPREHENSION_CHECK_RESPONSE': 'The AI gave a correct explanation but just stopped',
  'promptGeneration.EXAMPLE_NO_COMPREHENSION_CHECK_FEEDBACK':
    'Ask me a quick follow-up question to check if I actually got it',
  'promptGeneration.EXAMPLE_WRONG_DIFFICULTY_QUESTION': 'Create 5 quiz questions on cellular respiration',
  'promptGeneration.EXAMPLE_WRONG_DIFFICULTY_RESPONSE':
    'The AI generated basic recall questions like definitions and labelling',
  'promptGeneration.EXAMPLE_WRONG_DIFFICULTY_FEEDBACK':
    "I need application and analysis level questions for AP Biology — use Bloom's Taxonomy",
  'promptGeneration.EXAMPLE_MISSED_OBJECTIVE_QUESTION':
    'My students struggle with reading comprehension — give me an activity',
  'promptGeneration.EXAMPLE_MISSED_OBJECTIVE_RESPONSE':
    "The AI suggested read-a-passage-and-answer-questions — which is exactly what isn't working",
  'promptGeneration.EXAMPLE_MISSED_OBJECTIVE_FEEDBACK':
    'Suggest something interactive like reciprocal teaching, tied to a specific strategy like making inferences',
  'promptGeneration.QUESTION_ASKED_LABEL': 'Question asked',
  'promptGeneration.QUESTION_ASKED_PLACEHOLDER': 'What did the user ask?',
  'promptGeneration.AGENT_RESPONSE_LABEL': 'Agent response',
  'promptGeneration.AGENT_RESPONSE_PLACEHOLDER': 'Describe how the AI responded (in your own words, not the full text)',
  'promptGeneration.FEEDBACK_LABEL': 'Your feedback',
  'promptGeneration.FEEDBACK_PLACEHOLDER': 'What should be improved and why?',
  'promptGeneration.ADVANCED': 'Advanced',
  'promptGeneration.IMPROVEMENT_GRAPH_LABEL': 'Improvement graph',
  'promptGeneration.IMPROVEMENT_GRAPH_LOADING': 'Loading graphs…',
  'promptGeneration.IMPROVEMENT_GRAPH_EMPTY': 'No prompt graphs available',
  'promptGeneration.IMPROVEMENT_GRAPH_PLACEHOLDER': 'Select improvement graph',
  'promptGeneration.IMPROVEMENT_GRAPH_LOAD_ERROR': 'Could not load prompt graphs',
  'promptGeneration.TARGET_MODEL_LABEL': 'Target model',
  'promptGeneration.IMPROVE': 'Improve',
  'promptGeneration.IMPROVE_CONTEXT_REQUIRED':
    'Provide both the question and the agent response so the improver has interaction context.',
  'promptGeneration.IMPROVE_GRAPH_REQUIRED': 'Select an improvement graph.',
  'promptGeneration.IMPROVE_PROMPT_REQUIRED': 'System prompt (A) is required.',
  'promptGeneration.IMPROVE_FEEDBACK_REQUIRED': 'Feedback (F) is required.',
  'promptGeneration.IMPROVE_RUN_ERROR': 'Could not run the improvement graph.',
  'promptGeneration.IMPROVE_PARSE_ERROR': 'Improvement response was not valid JSON.',
  'promptGeneration.IMPROVE_EMPTY_RESULT': 'The improvement graph returned an empty prompt.',
  'promptGeneration.DIFF_MODAL_TITLE': 'Review improved prompt',
  'promptGeneration.DIFF_CURRENT_LABEL': 'Current prompt',
  'promptGeneration.DIFF_IMPROVED_LABEL': 'Improved prompt',
  'promptGeneration.DIFF_REPLACE': 'Replace',
  'promptGeneration.DIFF_CANCEL': 'Cancel',

  'nodeComponents.DETACH': 'Detach',
  'nodeComponents.DETACH_FROM_GROUP': 'Detach from group',
  'nodeComponents.UNGROUP': 'Ungroup',
  'nodeComponents.UNGROUP_NODES': 'Ungroup nodes',
  'nodeComponents.DEFAULT_START_LABEL': '__start__',
  'nodeComponents.DEFAULT_END_LABEL': '__end__',
  'nodeComponents.DEFAULT_AGENT_LABEL': 'agent',
  'nodeComponents.DEFAULT_TOOL_LABEL': 'tools',
  'nodeComponents.DEFAULT_SKILL_LABEL': 'skill',
  'nodeComponents.DEFAULT_GRAPH_LABEL': 'graph',
  'nodeComponents.DEFAULT_SUPERVISOR_LABEL': 'supervisor',

  'edgeModal.CONFIGURE_EDGE_CONDITION_TITLE': 'Configure Edge Condition',
  'edgeModal.CONFIGURE_EDGE_CONDITION_DESC':
    "Enter a JavaScript expression that evaluates to true when this edge should be taken. Use 'state' to access the current state of the graph.",
  'edgeModal.CONDITION_EXPRESSION_LABEL': 'Condition Expression',
  'edgeModal.CONDITION_EXPRESSION_PLACEHOLDER': "e.g., state.messages.at(-1).content.includes('summarize')",
  'edgeModal.INVALID_JS_EXPRESSION': 'Invalid JavaScript expression',

  'editNodeModal.EDIT_TOOL': 'Edit Tool',
  'editNodeModal.EDIT_SKILL': 'Edit Skill',
  'editNodeModal.EDIT_GRAPH': 'Edit Graph',
  'editNodeModal.LABEL_GRAPH_NAME': 'Graph name',
  'editNodeModal.LABEL_GRAPH_ID_FIELD': 'Graph ID',
  'editNodeModal.DEFAULT_GRAPH_NAME': 'graph',
  'editNodeModal.DEFAULT_GRAPH_DESCRIPTION': 'This graph node provides specialized behavior.',
  'editNodeModal.EDIT_SUPERVISOR': 'Edit Supervisor',
  'editNodeModal.EDIT_AGENT': 'Edit Agent',
  'editNodeModal.OTHER_PARAMETERS_JSON_INVALID': 'Other Parameters JSON is invalid. Please check the format.',
  'editNodeModal.PAYLOAD_JSON_INVALID': 'Payload JSON is invalid. Please check the format.',
  'editNodeModal.ADVANCED_OPTIONS_JSON_INVALID': 'Advanced Options JSON is invalid. Please check the format.',
  'editNodeModal.PROVIDER_PARAMETERS_JSON_INVALID': 'Provider Parameters JSON is invalid. Please check the format.',
  'editNodeModal.ADDITIONAL_METADATA_LABEL': 'Additional Metadata (JSON)',
  'editNodeModal.ADDITIONAL_METADATA_PLACEHOLDER': `Enter JSON like: ${JSON.stringify(
    {
      layout: {
        type: 'pills',
        position: 'top',
        alignment: 'left',
        direction: 'horizontal'
      }
    },
    null,
    2
  )}`,
  'editNodeModal.LABEL_PARSERS': 'Parsers',
  'editNodeModal.SYSTEM_PROMPT_PLACEHOLDER': 'Start writing your prompt or use AI-powered Prompt Generator!',
  'editNodeModal.USER_PROMPT_PLACEHOLDER': 'User prompt message...',
  'editNodeModal.DEFAULT_SUPERVISOR_DISPLAY_NAME': 'Supervisor',
  'editNodeModal.DEFAULT_AGENT_DISPLAY_NAME': 'Research Assistant',
  'editNodeModal.DEFAULT_TOOL_NAME': 'add',
  'editNodeModal.DEFAULT_TOOL_DESCRIPTION': 'Processes a input and returns the result.',
  'editNodeModal.DEFAULT_SKILL_NAME': 'skill',
  'editNodeModal.DEFAULT_SKILL_DESCRIPTION': 'This skill provides specialized behavior.',
  'editNodeModal.LABEL_SKILL_PROMPT': 'Skill',
  'editNodeModal.PLACEHOLDER_SKILL_PROMPT': 'Enter the skill...',
  'editNodeModal.DEFAULT_SUPERVISOR_SYSTEM_PROMPT':
    "You are a routing and output agent. Given the user's last message, carefully analyse and execute only those agents and give the output as is from the agents and in a clear and separated manner and do not mix the outputs from different agents. Also do not generate anything from your end STRICTLY. In the end just print the name of each agent that were used in individual brackets.",
  'editNodeModal.DEFAULT_AGENT_SYSTEM_PROMPT':
    'You are a helpful research assistant that can find information on any topic.',
  'editNodeModal.ERROR_GPT5_TEMPERATURE_MIN': 'Temperature must be at least 1 for GPT-5 and GPT-5-mini models.',
  'editNodeModal.ADDITIONAL_METADATA_JSON_INVALID': 'Additional Metadata JSON is invalid. Please check the format.',
  'editNodeModal.TAB_BASIC': 'Basic',
  'editNodeModal.TAB_MODEL': 'Model',
  'editNodeModal.TAB_MEMORY': 'Memory',
  'editNodeModal.TAB_MIDDLEWARE': 'Middleware',
  'editNodeModal.TAB_ADVANCED': 'Advanced',
  'editNodeModal.TAB_IMPLEMENTATION': 'Implementation',
  'editNodeModal.LABEL_DISPLAY_NAME': 'Display Name',
  'editNodeModal.LABEL_SECONDARY_NAME': 'Secondary Name',
  'editNodeModal.LABEL_SUPERVISOR_ID': 'Supervisor ID',
  'editNodeModal.LABEL_AGENT_ID': 'Agent ID',
  'editNodeModal.LABEL_AGENT_TYPE': 'Agent Type',
  'editNodeModal.LABEL_SYSTEM_PROMPT': 'System Prompt',
  'editNodeModal.LABEL_USER_PROMPT': 'User Prompt',
  'editNodeModal.MINIMIZE': 'Minimize',
  'editNodeModal.EXPAND_FULLSCREEN': 'Expand to full screen',
  'editNodeModal.A11Y_MINIMIZE_SYSTEM_PROMPT': 'Minimize system prompt',
  'editNodeModal.A11Y_EXPAND_SYSTEM_PROMPT': 'Expand system prompt',
  'editNodeModal.A11Y_SYSTEM_PROMPT': 'System Prompt',
  'editNodeModal.A11Y_MINIMIZE_USER_PROMPT': 'Minimize user prompt',
  'editNodeModal.A11Y_EXPAND_USER_PROMPT': 'Expand user prompt',
  'editNodeModal.A11Y_USER_PROMPT': 'User Prompt',
  'editNodeModal.LABEL_TOOLS_LIST': 'Tools List',
  'editNodeModal.SELECT_TOOL': 'Select a Tool',
  'editNodeModal.LOADING_TOOLS': 'Loading Tools...',
  'editNodeModal.LABEL_TOOL_NAME': 'Tool Name',
  'editNodeModal.LABEL_TOOL_ID': 'Tool ID',
  'editNodeModal.LABEL_DESCRIPTION': 'Description',
  'editNodeModal.VIEW_SELECTED_GRAPH': 'View selected graph',
  'editNodeModal.DESCRIPTION_PLACEHOLDER': 'Describe what this tool does...',
  'editNodeModal.LABEL_PROVIDER': 'Provider',
  'editNodeModal.SELECT_PROVIDER': 'Select Provider',
  'editNodeModal.LABEL_MODEL_NAME': 'Model Name',
  'editNodeModal.SELECT_MODEL': 'Select Model',
  'editNodeModal.LABEL_TEMPERATURE': 'Temperature',
  'editNodeModal.LABEL_MAX_TOKENS': 'Max Tokens',
  'editNodeModal.LABEL_TOOL_CHOICE': 'Tool Choice',
  'editNodeModal.TOOL_CHOICE_AUTO': 'Auto',
  'editNodeModal.TOOL_CHOICE_ANY': 'Any',
  'editNodeModal.TOOL_CHOICE_NONE': 'None',
  'editNodeModal.LABEL_PII_FILTER': 'PII filter',
  'editNodeModal.PII_FILTER_DESCRIPTION': 'Filters personal data from messages before they reach the model.',
  'editNodeModal.PII_FILTER_COLUMN_FIELD': 'Field',
  'editNodeModal.PII_FILTER_COLUMN_ACTION': 'Action',
  'editNodeModal.PII_FILTER_ACTION_REDACT': 'Redact',
  'editNodeModal.PII_FILTER_ACTION_MASK': 'Mask',
  'editNodeModal.PII_FILTER_ACTION_FOR_FIELD': 'Action for {field}',
  'editNodeModal.PII_FILTER_HISTORY_LABEL': 'PII filter',
  'editNodeModal.PII_FILTER_HISTORY_NO_FIELDS': 'PII filter enabled with no fields',
  'editNodeModal.MIDDLEWARE_CONFIG_LOADING': 'Loading middleware configuration...',
  'editNodeModal.MIDDLEWARE_CONFIG_ERROR': 'Failed to load middleware configuration.',
  'editNodeModal.MIDDLEWARE_CONFIG_RETRY': 'Retry',
  'editNodeModal.MIDDLEWARE_CONFIG_EMPTY': 'No PII filter fields are available.',
  'editNodeModal.MIDDLEWARE_CONFIG_MISSING_TENANT': 'Tenant is required to load middleware configuration.',
  'editNodeModal.MIDDLEWARE_CONFIG_UNAUTHORIZED': 'Unauthorized: Please login again',
  'editNodeModal.MIDDLEWARE_CONFIG_FORBIDDEN': 'Forbidden: You do not have permission to perform this action',
  'editNodeModal.MIDDLEWARE_PLUGIN_CONFIGURED': '{pluginKey} configured',
  'editNodeModal.LABEL_IS_INTERNAL': 'Is Internal',
  'editNodeModal.LABEL_REASONING_EFFORT': 'Reasoning Effort',
  'editNodeModal.LABEL_VERBOSITY': 'Verbosity',
  'editNodeModal.LABEL_MEMORY_TYPE': 'Memory Type',
  'editNodeModal.MEMORY_TYPE_BUFFER': 'Buffer',
  'editNodeModal.MEMORY_TYPE_SUMMARY': 'Summary',
  'editNodeModal.MEMORY_TYPE_NONE': 'None',
  'editNodeModal.LABEL_MAX_MESSAGES': 'Max Messages',
  'editNodeModal.LABEL_OTHER_PARAMETERS_JSON': 'Other Parameters (JSON)',
  'editNodeModal.OTHER_PARAMETERS_PLACEHOLDER': '{"top_p": 0.9, "frequency_penalty": 0.5}',
  'editNodeModal.LABEL_PROVIDER_PARAMETERS_JSON': 'Provider Parameters (JSON)',
  'editNodeModal.PROVIDER_PARAMETERS_PLACEHOLDER': '{"useResponsesApi": false}',
  'editNodeModal.LABEL_PARAMETERS': 'Parameters',
  'editNodeModal.ADD_PARAMETER': 'Add Parameter',
  'editNodeModal.TOOLTIP_MANDATORY_PARAMETER': 'Mandatory Parameter',
  'editNodeModal.TOOLTIP_OPTIONAL_PARAMETER': 'Optional Parameter',
  'editNodeModal.PLACEHOLDER_NAME': 'Name',
  'editNodeModal.PLACEHOLDER_DESCRIPTION': 'Description',
  'editNodeModal.LABEL_MCP_CONFIG': 'MCP Config',
  'editNodeModal.VALIDATE_JSON': 'Validate JSON',
  'editNodeModal.LABEL_URL': 'URL',
  'editNodeModal.URL_PLACEHOLDER': 'https://api.example.com/path',
  'editNodeModal.LABEL_AUTHENTICATION': 'Authentication',
  'editNodeModal.LABEL_METHOD': 'Method',
  'editNodeModal.LABEL_USE_STREAM': 'Use stream',
  'editNodeModal.LABEL_BEARER': 'Bearer',
  'editNodeModal.LABEL_HEADERS': 'Headers',
  'editNodeModal.ADD_HEADER': 'Add Header',
  'editNodeModal.IMPORT_CURL': 'Import curl',
  'editNodeModal.IMPORT_AS_CURL': 'Import as Curl',
  'editNodeModal.IMPORT_CURL_SUCCESS': 'Import curl Success',
  'editNodeModal.IMPORT': 'Import',
  'editNodeModal.HEADER_KEY_PLACEHOLDER': 'Header Key',
  'editNodeModal.HEADER_VALUE_PLACEHOLDER': 'Header Value',
  'editNodeModal.HIDE_VALUE': 'Hide value',
  'editNodeModal.SHOW_VALUE': 'Show value',
  'editNodeModal.REMOVE_HEADER': 'Remove header',
  'editNodeModal.LABEL_PAYLOAD': 'Payload',
  'editNodeModal.PAYLOAD_FIELD_KEY_PLACEHOLDER': 'Field Key',
  'editNodeModal.PAYLOAD_FIELD_VALUE_PLACEHOLDER': 'Field Value (use {{placeholder}} for dynamic values)',
  'editNodeModal.DYNAMIC_PLACEHOLDERS_TITLE': 'Dynamic Placeholders',
  'editNodeModal.DYNAMIC_PLACEHOLDERS_BODY': 'Use {{ and }} to create placeholders for dynamic values',
  'editNodeModal.DYNAMIC_PLACEHOLDERS_EXAMPLES':
    'Examples: {"field": "{{ userId }}"} or whole body: {{ questionJSON }}',
  'editNodeModal.LABEL_RESPONSE_FORMAT': 'Response Format',
  'editNodeModal.LABEL_IMPLEMENTATION': 'Implementation',
  'editNodeModal.REGENERATE_CODE': 'Regenerate Code',
  'editNodeModal.VALIDATE_CODE': 'Validate Code',
  'editNodeModal.LABEL_ADVANCED_OPTIONS_JSON': 'Advanced Options (JSON)',
  'editNodeModal.LABEL_THINKING_START_MESSAGE': 'Thinking Start Message',
  'editNodeModal.LABEL_THINKING_END_MESSAGE': 'Thinking End Message',
  'editNodeModal.DEFAULT_THINKING_START_MESSAGE_SUPERVISOR': 'Analyzing the request and determining the best agent...',
  'editNodeModal.DEFAULT_THINKING_START_MESSAGE_AGENT': 'Agent is determining the best approach...',
  'editNodeModal.DEFAULT_THINKING_START_MESSAGE_TOOL': 'Searching for relevant information...',
  'editNodeModal.DEFAULT_THINKING_END_MESSAGE_TOOL': 'Getting information is completed. Processing results...',
  'editNodeModal.PROMPT_GENERATOR_ERROR': 'Prompt generation failed. Please try again.',
  'editNodeModal.SAVE_CHANGES': 'Save Changes',
  'editNodeModal.HIDE_PREVIEW': 'Hide Preview',
  'editNodeModal.SHOW_PREVIEW': 'Show Preview',
  // Graph Tester Modal Constants
  'graphTester.SHOW_STATS': 'Show Stats',
  'graphTester.HIDE_STATS': 'Hide Stats',
  'graphTester.TOGGLE_STATS': 'Toggle Stats',
  'graphTester.PROCESSING': 'Processing...',
  'graphTester.TITLE_PREFIX': 'Test Graph:',
  'graphTester.CLOSE': 'Close',
  'graphTester.BOOK_ID_LABEL': 'Book ID',
  'graphTester.BOOK_ID_PLACEHOLDER': 'Select Book Id...',
  'graphTester.PRODUCT_MODEL_PLACEHOLDER': 'Select Product Model...',
  'graphTester.PAGE_ID_LABEL': 'Page Id',
  'graphTester.IMAGE_CONTEXT_LABEL': 'Image Context',
  'graphTester.TOGGLE_PROPERTIES_MODE': 'Toggle Properties Mode',
  'graphTester.VALIDATE_JSON': 'Validate JSON',
  'graphTester.CLEAR_POPUP_PARAMS': 'Clear popup parameters',
  'graphTester.RESET': 'Reset',
  'graphTester.CLEAR_AND_REMOVE_DB': 'Clear popup and remove parameters from DB',
  'graphTester.NO_EDIT_ACCESS': "You don't have edit access",
  'graphTester.DELETE': 'Delete',
  'graphTester.SAVE_TO_DB': 'Save current parameters to DB',
  'graphTester.SAVE': 'Save',
  'graphTester.INVALID_JSON_PREFIX': 'Invalid JSON:',
  'graphTester.VALID_JSON': 'Valid JSON',
  'graphTester.KEY_NAME_PLACEHOLDER': 'Key Name',
  'graphTester.KEY_VALUE_PLACEHOLDER': 'Key Value',
  'graphTester.USER_INPUT_LABEL': 'User Input',
  'graphTester.NEW_TOPIC': 'New topic',
  'graphTester.USE_STACK_B': 'Use Stack B',
  'graphTester.INPUT_PLACEHOLDER': 'Enter your input...',
  'graphTester.RUNNING': 'Running…',
  'graphTester.CANCEL_REQUEST': 'Cancel Request',
  'graphTester.PROCESSING_GRAPH': 'Processing',
  'graphTester.RUN_GRAPH': 'Run Graph',
  'graphTester.FETCHING_EXECUTION_LOGS': 'Fetching Execution Logs...',
  'graphTester.SHOW_EXECUTION_LOGS': 'Show Execution Logs',
  'graphTester.FETCHING_LLM_LOGS': 'Fetching LLM Logs...',
  'graphTester.SHOW_LLM_LOGS': 'Show LLM Logs',
  'graphTester.RUN_EVALUATION': 'Run Evaluation',
  'graphTester.RUN_EVALUATION_CRITERIA': 'Run Evaluation Criteria',
  'graphTester.FETCHING_EVALUATION_CRITERIA': 'Fetching Evaluation Criteria...',
  'graphTester.EVALUATION_REQUIRES_RUBRIC_ID': 'Save evaluation to Run',
  'graphTester.SELECT_EVALUATION_RUBRIC': 'Select evaluation rubric',
  'graphTester.EVALUATION_REQUIRES_REQUEST_ID': 'Run graph first to get request id.',
  'graphTester.EVAL_LENS_EVALUATION_TITLE': 'Evaluation Results',
  'graphTester.SHOW_STRUCTURED_EVAL': 'Show structured evaluation',
  'graphTester.RAW_RESPONSE': 'Raw response',
  'graphTester.SCORE': 'Score',
  'graphTester.CRITERION': 'Criterion',
  'graphTester.RATIONALE': 'Rationale',
  'graphTester.EVAL_FEEDBACK_EMPTY': 'No evaluation feedback available for this run.',
  'graphTester.SHOW_VISUAL_LOGS': 'Show Visual Logs',
  'graphTester.VISUAL_LOGS_MODAL_TITLE': 'Visual Logs',
  'graphTester.SHOW_RAW_RESPONSE': 'Show Raw Response',
  'graphTester.SHOW_FORMATTED_RESPONSE': 'Show Formatted Response',
  'graphTester.RUN_IN_CHATBOT': 'Run in Chatbot',
  'graphTester.EXECUTION_LOG': 'Execution Log',
  'graphTester.AUDIT_LOG': 'Audit Log',
  'graphTester.EXECUTION_LOGS_AUDIT_FALLBACK':
    'Execution logs are not available for this request ID. Showing audit logs instead.',
  'graphTester.EXECUTION_LOGS_NOT_FOUND': 'Logs not found',
  'graphTester.EXECUTION_LOGS_FETCH_FAILED': 'Failed to fetch execution logs',
  'graphTester.TRACING_AND_OBSERVABILITY': 'Tracing and Observability',
  'observe.TRACING_HELPER':
    'View LangGraph execution trace, spans, token usage, and step-by-step previews for this request.',
  'observe.TRACING_REQUEST_ID': 'Request ID: {id}',
  'graphTester.TRACING_MODAL_TITLE': 'Tracing and Observability',
  'graphTester.TRACE_INPUT': 'Input',
  'graphTester.TRACE_OUTPUT': 'Output',
  'graphTester.TRACE_SEARCH': 'Search',
  'graphTester.TRACE_SEARCH_PLACEHOLDER': 'Search observations…',
  'graphTester.TRACE_LABEL': 'Trace',
  'graphTester.TRACE_HIDDEN_DEBUG_OBSERVATIONS': '{count} hidden DEBUG observations.',
  'graphTester.HIDDEN_OBSERVATIONS': '{count} hidden observations below DEFAULT level.',
  'graphTester.SHOW_ALL_OBSERVATIONS': 'Show all',
  'graphTester.NO_OBSERVATIONS': 'No observations found in execution logs.',
  'graphTester.SELECT_OBSERVATION': 'Select an observation',
  'graphTester.TRACE_TITLE_PREFIX': 'Trace {name}',
  'graphTester.TRACE_PREVIEW': 'Preview',
  'graphTester.TRACE_PROMPT': 'Prompt',
  'graphTester.TRACE_PROMPT_EMPTY': 'No prompt messages found for this observation.',
  'graphTester.TRACE_PROMPT_SYSTEM': 'System',
  'graphTester.TRACE_PROMPT_CONTEXT': 'Context',
  'graphTester.TRACE_PROMPT_TOOL': 'Tool',
  'graphTester.TRACE_LOG_VIEW': 'Log View',
  'graphTester.TRACE_USAGE': 'Usage',
  'graphTester.TRACE_METADATA': 'Metadata',
  'graphTester.TRACE_TOOLS': 'Tools',
  'graphTester.TRACE_RAW': 'Raw',
  'graphTester.TRACE_TREE_VIEW': 'Tree',
  'graphTester.TRACE_TIMELINE_VIEW': 'Timeline',
  'graphTester.TRACE_MIN_LEVEL': 'Min Level: {level}',
  'graphTester.TRACE_MIN_LEVEL_MENU': 'Minimum Level',
  'graphTester.TRACE_LIST_TITLE': 'Traces',
  'graphTester.TRACE_LIST_SEARCH': 'Search traces…',
  'graphTester.TRACE_COLLAPSE_ALL': 'Collapse all',
  'graphTester.TRACE_EXPAND_ALL': 'Expand all',
  'graphTester.TRACE_COLLAPSE': 'Collapse',
  'graphTester.TRACE_EXPAND': 'Expand',
  'graphTester.TRACE_LATENCY': 'Latency: {value}',
  'graphTester.TRACE_ENV_DEFAULT': 'Env: default',
  'graphTester.TRACE_SECTION_USER': 'User',
  'graphTester.TRACE_SECTION_ASSISTANT': 'Assistant',
  'graphTester.TRACE_SECTION_AI_RESPONSE': 'AI Response',
  'graphTester.TRACE_SECTION_ADDITIONAL_INPUT': 'Additional Input',
  'graphTester.TRACE_SECTION_METADATA': 'Metadata',
  'graphTester.TRACE_SECTION_TOOL_OUTPUT': 'Tool Output',
  'graphTester.TRACE_SECTION_PRIOR_SESSION_CHAT': 'Prior Session Chat',
  'graphTester.TRACE_SECTION_RAG_CONTENT': 'RAG Content',
  'graphTester.TRACE_SECTION_IMAGE_DESCRIPTION': 'Image Description',
  'graphTester.SHOW_RAW_LOGS': 'Show Raw Logs',
  'graphTester.SHOW_SIMPLIFIED_LOGS': 'Show Simplified Logs',
  'graphTester.TRACE_SPANS_COUNT': '{count} spans',
  'graphTester.TRACE_TOTAL_DURATION': '{duration} total',
  'graphTester.TRACE_TOKEN_SUMMARY': '{total} tokens ({input} in / {output} out)',
  'graphTester.TRACE_ID': 'ID: {id}',
  'graphTester.TRACE_PATH_COLUMN': 'Path',
  'graphTester.TRACE_VALUE_COLUMN': 'Value',
  'graphTester.TRACE_RESIZE_PANELS': 'Drag to resize panels',
  'graphTester.MIN_LEVEL': 'Min level',
  'graphTester.SHOW_RAW_JSON': 'JSON',
  'graphTester.SHOW_FORMATTED_JSON': 'Show formatted',
  'graphTester.COPY_INPUT': 'Copy input',
  'graphTester.COPY_OUTPUT': 'Copy output',
  'graphTester.LLM_LOG': 'LLM Log',
  'graphTester.DOWNLOAD_AS_CURL': 'Download as Curl',
  'graphTester.EVALUATION_CRITERIA': 'Evaluation criteria',
  // Graph Tester Error Messages
  'graphTester.ERROR_INVALID_JSON': 'Invalid JSON input.',
  'graphTester.ERROR_STREAM_FAILED': 'Stream read failed',
  'graphTester.ERROR_REQUEST_FAILED': 'Request failed',
  'graphTester.ERROR_JSON_OBJECT_REQUIRED': 'Dynamic properties JSON must be an object with key/value pairs.',
  'graphTester.ERROR_VALID_JSON_REQUIRED': 'Please provide a valid JSON object.',
  // Graph List Popup Constants
  'graphList.PROCESSING': 'Processing...',
  'graphList.LOAD_GRAPH': 'Load Graph',
  'graphList.PROMOTE_GRAPH': 'Promote Graph',
  'graphList.PROMOTING_GRAPH': 'Promoting graph...',
  'modalPopup.PROMOTE_GRAPH_LABEL': 'Promote the loaded graph to the selected target environment:',
  'modalPopup.GRAPH_ID': 'Graph ID',
  'modalPopup.CURRENT_DEFAULT_VERSION': 'Current Default Version: {version}',
  'graphList.PROMOTE_SUCCESS_DIALOG_TITLE': 'Graph Promoted',
  'graphList.PROMOTE_SUCCESS_DIALOG_MESSAGE':
    'The selected graph has been successfully promoted to {targetEnv} as version {version} (DRAFT).',
  'graphList.PROMOTE_SUCCESS_DIALOG_MESSAGE_NO_VERSION':
    'The selected graph has been successfully promoted to {targetEnv} (DRAFT).',
  'graphList.PROMOTE_SUCCESS_DIALOG_WARNING':
    'Warning: Tool calls may break after promotion. Please review all tool and API connections in the promoted graph.',
  'graphList.PROMOTE_ERROR_MESSAGE': 'Something went wrong, please try again.',
  'graphList.SEARCH_PLACEHOLDER': 'Search graphs by name or Id...',
  'graphList.FILTER_ALL': 'All',
  'graphList.FILTER_MINE': 'Mine',
  'graphList.FILTER_SHARED': 'Shared With Me',
  'graphList.LOADING': 'Loading graphs...',
  'graphList.LOADING_LANGGRAPH_CODE': 'Loading LangGraph code...',
  'graphList.NO_GRAPHS_FOUND': 'No graphs found',
  'graphList.OWNER_PREFIX': 'Owner: ',
  'graphList.MANAGE_ACCESS_TITLE': 'Manage Access',
  'graphList.EDIT_TITLE_TOOLTIP': 'Edit Graph Title',
  'graphList.ERROR_GRAPH_NAME_REQUIRED': 'Graph name is required!',
  'graphList.SUCCESS_UPDATE_TITLE': 'Graph title updated successfully!',
  'graphList.FAILED_UPDATE_TITLE': 'Failed to update graph title',
  'graphList.ERROR_UPDATE_TITLE': 'Error updating graph title',
  'graphList.SAVE_TITLE': 'Save',
  'graphList.CANCEL_TITLE': 'Cancel',
  'graphList.ID_PREFIX': 'Graph ID: ',
  'graphList.LAST_MODIFIED_PREFIX': 'Last modified: ',
  'graphList.MODIFIED_BY_PREFIX': 'Modified by: ',
  'graphList.VERSION_LABEL': 'Version:',
  'graphList.DEFAULT_SUFFIX': ' (Default)',
  'graphList.SELECT_VERSION_PLACEHOLDER': 'Select Version...',
  'graphList.DEFAULT_CHIP': 'Default',
  'graphList.CURRENTLY_LOADED_TOOLTIP': 'Loaded',
  'graphList.SHARE_BUTTON': 'Share',
  'graphList.SHOW_CODE_BUTTON': 'Show LangGraph Code',
  'graphList.DELETE_BUTTON': 'Delete Graph',
  'graphList.SET_DEFAULT_BUTTON': 'Set as Default',
  'graphList.SHOW_HISTORY_BUTTON': 'Show History',
  'graphList.CONFIRM_SET_DEFAULT_WITH_VERSION':
    'Are you sure you want to set this LIVE version as default? Current default LIVE Version: ',
  'graphList.CONFIRM_SET_DEFAULT': 'Are you sure you want to set this LIVE version as default?',
  'graphList.DELETE_TITLE': 'Delete Graph',
  'graphList.CONFIRM_DELETE_PREFIX': 'Are you sure you want to delete "',
  'graphList.CONFIRM_DELETE_SUFFIX': 'This action cannot be undone.',
  'graphList.GENERATED_CODE_TITLE': 'Generated LangGraph Code:',
  'graphList.CLOSE': 'Close',
  'graphList.ERROR_SHOW_GRAPH': 'Error while showing graph: ',
  'graphList.ERROR_SHOW_GRAPH_GENERIC': 'Failed to show graph. Please try again.',
  'graphList.ERROR_SET_DEFAULT': 'Failed to set default: ',
  'graphList.SUCCESS_SET_DEFAULT': 'Success',
  'graphTester.JSON_MODE': '{JSON}',
  'graphTester.SETTINGS': 'Settings',
  'graphTester.ADVANCED_SETTINGS': 'Advanced Settings',
  'graphTester.SKIP_HISTORY': 'Skip History',
  'graphTester.SKIP_CONTENT_FILTERING': 'Skip Content Filtering',
  // Advanced Settings
  'advancedSettings.SAVE_GRAPH_FIRST': 'Please save the graph first to update settings',
  'advancedSettings.CANNOT_EDIT_LIVE': 'Cannot edit settings for live graphs. Create a new version first.',
  'advancedSettings.TAB_BASIC': 'Basic',
  'advancedSettings.TAB_OTHER_PARAMS': 'Additional Params',
  'advancedSettings.LABEL_PATTERN': 'Pattern',
  'advancedSettings.AUDIO_OPTIONS': 'Audio Options',
  'advancedSettings.AUDIO_ENABLE': 'Enable Audio',
  'advancedSettings.PROVIDERS': 'Providers',
  'advancedSettings.SELECT_PROVIDER': 'Select a provider',
  'advancedSettings.AUDIO_MODELS': 'Audio Models',
  'advancedSettings.SELECT_AUDIO_MODEL': 'Select an audio model',
  'advancedSettings.SELECT_A_VOICE': 'Select a voice',
  'advancedSettings.LOADING_AUDIO_OPTIONS': 'Loading audio options...',
  'advancedSettings.AUDIO_OPTIONS_LOAD_ERROR': 'Failed to load audio providers. Please try again.',
  'advancedSettings.AUDIO_OPTIONS_TENANT_REQUIRED': 'Tenant is required to load audio providers.',
  'advancedSettings.COMPLETE_AUDIO_SELECTION': 'Select a provider, audio model, and voice before saving',
  'patternDialog.TITLE': 'Select Graph Pattern',
  'patternDialog.DESCRIPTION':
    'Choose a workflow pattern for this graph. You can change it later in Advanced Settings.',
  'patternDialog.NONE_OPTION': 'None',
  'patternDialog.SKIP': 'Skip',
  'patternDialog.CONFIRM': 'Confirm',
  'advancedSettings.ENABLE_MEMORY_SAVER': 'Enable Memory Saver',
  'advancedSettings.ENABLE_MEMORY_SAVER_DESCRIPTION': 'Optimizes memory usage for complex graphs.',
  'advancedSettings.ENABLE_AGENT_THINKING': 'Enable Agent Thinking',
  'advancedSettings.OTHER_PARAMS_JSON': 'Additional Parameters (JSON)',
  'advancedSettings.VALID_JSON': 'Valid JSON',
  'advancedSettings.INVALID_JSON': 'Invalid JSON',
  'advancedSettings.VALIDATE_JSON': 'Validate JSON',
  'advancedSettings.VALIDATE_JSON_FIRST': 'Please validate JSON first',
  'studio.LOADING': 'Loading Studio...',
  // AET Topic View Constants
  'aetTopic.LABEL_JSON': 'JSON',
  'aetTopic.NO_TOPICS_AVAILABLE': 'No Topics Available',
  'aetTopic.NO_RAW_DATA': 'No raw data available',
  'aetTopic.TOPIC_NAME_LABEL': 'Topic Name:',
  'aetTopic.SHORT_TOPIC_LABEL': 'Short Topic:',
  'aetTopic.INJECTION_BLOCK_ID_LABEL': 'Injection After Block ID:',
  'aetTopic.EVIDENCE_QUOTES_LABEL': 'Evidence Quotes:',
  'aetTopic.TOTAL_TOPICS': 'Total Topics:',
  'aetTopic.STATUS_LIVE': 'Live in Production',
  'aetTopic.STATUS_DRAFT': 'DRAFT',
  'aetTopic.STATUS_REVIEW': 'REVIEW',
  'aetTopic.DISABLED_RAW_MODE': 'Disabled in Raw Data mode',
  // AET Topic Edit Dialog Constants
  'aetTopic.UPDATE_TOPIC_NAME_LABEL': 'Update Topic Name',
  'aetTopic.UPDATE_SHORT_TOPIC_LABEL': 'Update Short Topic',
  'aetTopic.TOPIC_NAME_REQUIRED': 'Topic name is required',
  'aetTopic.INJECTION_BLOCK_ID_HELPER': 'Must be a valid Base64-encoded value',
  'aetTopic.INJECTION_BLOCK_ID_ERROR': 'Invalid Base64 format. Please enter a valid Base64-encoded value.',
  'aetTopic.EVIDENCE_QUOTES_EDIT_LABEL': 'Evidence Quotes:',
  'aetTopic.EVIDENCE_BLOCK_ID_LABEL': 'Block ID',
  'aetTopic.EVIDENCE_BLOCK_ID_HELPER': 'Must be a valid Base64-encoded value',
  'aetTopic.EVIDENCE_BLOCK_ID_ERROR': 'Invalid Base64 format. Please enter a valid Base64-encoded value.',
  'tocSearch.PAGE_ID_LABEL': 'Search by Page ID',
  'tocSearch.PAGE_NOT_FOUND': 'Page ID not found in this book',
  'selectComponent.TARGET_TENANT': 'Target Tenant',
  'selectComponent.TARGET_ENVIRONMENT': 'Target Environment',
  'selectComponent.SELECT_TENANT': 'Select Tenant..',
  'validation.FIELD_REQUIRED': 'This field is required.',
  'validation.INVALID_INPUT': 'Invalid input.',
  'tenantFeature.ADD_CONFIGURATION': 'Add Configuration',
  'tenantFeature.ADD_MODAL_TITLE': 'Add Base Feature Configuration',
  'tenantFeature.ADD_BASE_INFO':
    'Adds a base configuration only. Other tenants are not affected until an admin sets ON or OFF for that tenant.',
  'tenantFeature.FIELD_KEY': 'Key',
  'tenantFeature.FIELD_NAME': 'Name',
  'tenantFeature.FIELD_VALUE': 'Value',
  'tenantFeature.FIELD_DESCRIPTION': 'Description',
  'tenantFeature.VALUE_ON': 'ON',
  'tenantFeature.VALUE_OFF': 'OFF',
  'tenantFeature.DUPLICATE_KEY': 'A configuration with this key already exists.',
  'tenantFeature.ADD_SUCCESS': 'Configuration added successfully',
  'tenantFeature.ADD_ERROR': 'Error in Adding Configuration',
  'observe.SELECT_BOOK_FOR_AUDIO_INTENT': 'Please select a book.',
  'observe.ENTITY_TYPE': 'Entity Type',
  'observe.FETCHING_DATA': 'Fetching data...',

  'telemetry.SEARCH_REQUIRED': 'Please enter at least one search field.',
  'telemetry.METADATA': 'Metadata',
  'telemetry.USER_INPUT': 'User Input/Command',
  'telemetry.SUMMARY': 'Summary',
  'telemetry.TRACE_ID': 'Trace Id',
  'telemetry.SERVER_DATE_TIME': 'Date / Time (GMT)',
  'telemetry.SERVICE_NAME': 'Service Name',
  'telemetry.USER_ID': 'User Id',
  'telemetry.SESSION_ID': 'Session Id',
  'telemetry.CONVERSATION_ID': 'Conversation Id',
  'telemetry.PRIMARY_ID': 'Primary Id',
  'telemetry.QUESTION': 'Question',
  'telemetry.PROMPT': 'Prompt',
  'telemetry.RESPONSE': 'Response',
  'telemetry.AI_RESPONSE': 'AI Response',
  'telemetry.TOOL_CALLS': 'Tool Calls',
  'telemetry.TOOL_CALL_NAME': 'Name',
  'telemetry.TOOL_CALL_ID': 'Tool Call ID',
  'telemetry.TOOL_CALL_DURATION': 'Duration (ms)',
  'telemetry.TOOL_CALL_INPUT': 'Input',
  'telemetry.TOOL_CALL_OUTPUT': 'Output',
  'telemetry.USAGE_AND_MODELS': 'Usage & Models',
  'telemetry.REQUEST_MODEL': 'Request Model',
  'telemetry.RESPONSE_MODEL': 'Response Model',
  'telemetry.INPUT_TOKENS': 'Input Tokens',
  'telemetry.OUTPUT_TOKENS': 'Output Tokens',
  'telemetry.TOTAL_TOKENS': 'Total Tokens',
  'telemetry.NO_PROMPT_DATA': 'No prompt data available for this trace.',
  'telemetry.NO_RESPONSE_DATA': 'No response data available for this trace.',
  'telemetry.NO_TOOL_CALL_DATA': 'No tool call data available for this trace.',
  'telemetry.NO_USAGE_DATA': 'No token usage or model data available for this trace.',
  'targetTenants.INVALID_RESPONSE_FORMAT': 'Invalid response format for target tenants',
  'targetTenants.FETCH_ERROR': 'Error fetching target tenants',
  'common.CURRENT': '(Current)',
  'graphList.HISTORY_FETCH_SUCCESS': 'Graph history fetched successfully',
  'graphList.HISTORY_NO_DATA': 'No history data found for this graph.',
  'graphList.HISTORY_FETCH_ERROR': 'Failed to fetch graph history. Please try again.',
  'graphVersionHistory.SHOW_PANEL': 'Show Version History',
  'graphVersionHistory.PANEL_TITLE': 'Version History',
  'graphVersionHistory.LAST_UPDATED': 'Last updated {time}',
  'graphVersionHistory.BACK_TO_DOCUMENT': 'Back to document',
  'graphVersionHistory.SAVE_A_COPY': 'Save a Copy',
  'graphVersionHistory.RESTORE': 'Restore',
  'graphVersionHistory.SHOW_EDITS': 'Show edits',
  'graphVersionHistory.CURRENT_VERSION': 'Current Version',
  'graphVersionHistory.SELECT_VERSION_HINT': 'Select a version from the Version History pane.',
  'graphVersionHistory.HISTORICAL_VIEW_BANNER': 'Historical view — you are previewing a past version',
  'graphVersionHistory.HEADER_CURRENT': 'Current version',
  'graphVersionHistory.GROUP_JUST_NOW': 'Just now',
  'graphVersionHistory.GROUP_YESTERDAY': 'Yesterday',
  'graphVersionHistory.YESTERDAY_AT': 'Yesterday, {time}',
  'graphVersionHistory.GROUP_OLDER': 'Earlier',
  'graphVersionHistory.LOAD_MORE': 'Load more',
  'graphVersionHistory.DIALOG_NEWER_TITLE': 'Newer version available',
  'graphVersionHistory.DIALOG_NEWER_MESSAGE':
    'A newer version exists. Do you want to see the latest changes made by other users first?',
  'graphVersionHistory.DIALOG_NEWER_YES': 'Yes',
  'graphVersionHistory.DIALOG_NEWER_NO': 'No',
  'graphVersionHistory.DIALOG_DRAFT_TITLE': 'Override draft?',
  'graphVersionHistory.DIALOG_DRAFT_MESSAGE': 'This will override your current draft changes. Continue?',
  'graphVersionHistory.DIALOG_DRAFT_CONTINUE': 'Continue',
  'graphVersionHistory.SAVE_COPY_DIALOG_TITLE': 'Save a copy',
  'graphVersionHistory.SAVE_COPY_NAME_PLACEHOLDER': 'Name for the new graph',
  'graphVersionHistory.RESTORING': 'Restoring version...',
  'graphVersionHistory.RESTORE_SUCCESS': 'Graph restored from selected version.',
  'graphVersionHistory.RESTORE_FAILED': 'Failed to restore the selected version.',
  'graphVersionHistory.RESTORE_PAYLOAD_ERROR': 'Could not build restore data from the selected version.',
  'graphVersionHistory.SAVE_COPY_FAILED': 'Failed to save a copy of this version.',
  'graphVersionHistory.SAVE_COPY_PAYLOAD_ERROR': 'Could not build copy data from the selected version.',
  'graphVersionHistory.CONFIG_CHANGES_BUTTON': 'Graph settings ({count})',
  'graphVersionHistory.CONFIG_DIFF_TITLE': 'Graph settings',
  'graphVersionHistory.CONFIG_DIFF_EMPTY_TITLE': 'No graph setting changes',
  'graphVersionHistory.CONFIG_DIFF_EMPTY_SUBTITLE':
    'Advanced settings match between the selected and current versions.',
  'graphVersionHistory.CLOSE_CONFIG_DIFF': 'Close graph settings comparison',
  'graphConflict.DIALOG_TITLE': 'Graph changed while you were editing',
  'graphConflict.DIALOG_MESSAGE':
    'Another user saved changes to agents or tools. Choose how to resolve the conflict. Layout-only changes are merged automatically.',
  'graphConflict.PROPERTY_DIALOG_MESSAGE':
    'Another user changed the same properties you edited. Resolve each conflict below, then save. Other non-conflicting differences are shown for reference.',
  'graphConflict.NO_PROPERTY_CONFLICTS': 'No overlapping property conflicts detected.',
  'graphConflict.CONFLICTS_SECTION': 'Conflicts ({count})',
  'graphConflict.DIFFERENCES_SECTION': 'Other differences ({count})',
  'graphConflict.DIFFERENCES_MESSAGE':
    'These properties differ between your save and the latest revision but do not require a choice. They will merge automatically when you save.',
  'graphConflict.NO_DIFFERENCES': 'No other property differences to show.',
  'graphConflict.LATEST_OTHER_USER': 'Latest ({userEmail})',
  'graphConflict.OTHER_USER_FALLBACK': 'other user',
  'graphConflict.YOUR_CHANGE': 'Your change',
  'graphConflict.RESOLVED': 'Resolved',
  'graphConflict.APPROVE': 'Use Latest',
  'graphConflict.MERGE': 'Merge',
  'graphConflict.IGNORE': 'Keep Mine',
  'graphConflict.PREVIEW_LABEL': 'Will be saved',
  'graphConflict.PREVIEW_APPROVE_HINT': 'Uses the latest saved value.',
  'graphConflict.PREVIEW_MERGE_HINT': 'Combines both values (latest first, then yours, separated by ---).',
  'graphConflict.PREVIEW_MERGE_EDITABLE_HINT':
    'Edit the merged text below before saving. Latest values are combined by default.',
  'graphConflict.PREVIEW_IGNORE_HINT': 'Keeps your change.',
  'graphConflict.SAVE_RESOLVED': 'Save after resolving',
  'graphConflict.SAVE_RESOLVED_SUCCESS': 'Conflicts resolved and graph saved successfully.',
  'graphConflict.RESOLVE_ALL_FIRST': 'Please choose Use Latest or Keep Mine for every conflict.',
  'graphConflict.RECONFLICT_MESSAGE': 'New conflicts detected. Another user saved while you were resolving.',
  'graphConflict.FALLBACK_MESSAGE':
    'Could not compute property-level conflicts. Reload the latest graph or try saving again.',
  'graphConflict.RELOAD_LATEST': 'Reload latest graph',
  'graphConflict.ACCEPT_THEIRS': 'Accept their changes',
  'graphConflict.NODES_UPDATED': '{count} agent/tool node(s) updated',
  'graphConflict.NODES_ADDED': '{count} node(s) added by others',
  'graphConflict.NODES_REMOVED': '{count} node(s) removed by others',
  'graphConflict.MERGE_SUCCESS': 'Changes merged and saved successfully.',
  'graphConflict.PUBLISHED_DURING_EDIT_AUTO_VERSION':
    'This Graph version was published while you were editing. Created a new version with your changes.',
  'graphConflict.PUBLISH_RESOLVED_SUCCESS': 'Conflicts resolved and graph published successfully.',
  'graphConflict.PUBLISH_RESOLVE_CONTEXT_ERROR':
    'Could not complete publish conflict resolution. Please try publishing again.',
  'graphConflict.UNKNOWN_NODE': 'Unknown',
  'graphConflict.GRAPH_CONFIG': 'Graph Config',
  'graphConflict.CONFIG_PREFIX': 'Config',
  'graphConflict.PROMPT_VERSION_REF': 'Prompt Version Ref',
  'graphConflict.USER_PROMPT': 'User Prompt',
  'graphConflict.SYSTEM_PROMPT': 'System Prompt',
  'graphTool.RUN_GRAPH_API_LABEL': 'API endpoint',
  'graphTool.RUN_GRAPH_API_PLACEHOLDER': 'Select a graph and version',
  'modalPopup.COMMENT_PLACEHOLDER': 'Enter your comment (optional)',
  // History Modal Constants
  'history.SHOW_HISTORY': 'Show History',
  'history.LOADING_HISTORY': 'Loading history...',
  'history.TITLE_PREFIX': 'History: ',
  'history.GRAPH_HISTORY_TITLE': 'GRAPH HISTORY',
  'history.UNKNOWN_GRAPH': 'Unknown Graph',
  'history.INVALID_DATE': 'Invalid Date',
  'history.COMPARE_WITH_VERSION': 'Compare with version:',
  'history.LOADING': 'Loading...',
  'history.SELECT_VERSION': 'Select a version to compare...',
  'history.LOAD_SUCCESS': 'Historical graph data loaded successfully for {name}',
  'history.LOAD_SUCCESS_DEFAULT': 'graph',
  'history.NO_DATA_FOUND': 'No graph data found for the selected history version.',
  'history.LOAD_FAILED': 'Failed to load historical graph data. Please try again.',
  'history.COMPARING_PREFIX': 'Comparing: Current Graph vs (',
  'history.NO_SELECTION': 'No Selection',
  'history.DIFF_HINT': '(Node diff is highlighted in below graph)',
  'history.LOADING_GRAPH': 'Loading graph...',
  'history.NO_GRAPH_DATA': 'No current graph data available',
  'history.CLOSE_DIFF_VIEWER': 'Close node diff viewer',
  'history.DEFAULT_EDGE_LABEL': 'continue',
  'history.ENTER_FULLSCREEN': 'Enter fullscreen',
  'history.EXIT_FULLSCREEN': 'Exit fullscreen',
  // Node Diff Viewer Constants
  'history.ADDED_NODE': 'Added Node',
  'history.MODIFIED_NODE': 'Modified Node',
  'history.DELETED_NODE': 'Deleted Node',
  'history.ADDED': 'Added',
  'history.MODIFIED': 'Modified',
  'history.DELETED': 'Deleted',
  'history.NODE': 'Node',
  'history.NOT_SET': 'Not set',
  'history.REMOVED': 'Removed',
  'history.POSITION': 'Position',
  'history.NO_CHANGES_TITLE': 'No detailed changes found for this node',
  'history.NO_CHANGES_SUBTITLE': 'This node may have been moved or have minimal modifications',
  // Before/After Pills Constants
  'history.DISPLAY_NAME': 'Display Name',
  'history.LEGEND_REMOVED': 'Removed',
  'history.LEGEND_ADDED': 'Added',
  'history.BEFORE_HISTORICAL': 'Before (Historical)',
  'history.AFTER_CURRENT': 'After (Current)',
  // Graph Diff Viewer Constants
  'history.FIELD_PROMPT': 'Prompt',
  'history.FIELD_AI_MODEL': 'AI Model',
  'history.FIELD_TEMPERATURE': 'Temperature',
  'history.FIELD_MAX_TOKENS': 'Max Tokens',
  'history.FIELD_PROVIDER': 'Provider',
  'history.FIELD_METHOD_NAME': 'Method Name',
  'history.FIELD_IMPLEMENTATION': 'Implementation',
  'history.CODE_UPDATED': 'Code updated',
  'history.FIELD_SCHEMA': 'Schema',
  'history.SCHEMA_UPDATED': 'Schema updated',
  'history.FIELD_DESCRIPTION': 'Description',
  'history.VERSION_DIFFERENCES': 'Version Differences',
  'history.CHANGES_SUMMARY': '📊 Changes Summary',
  'history.NODES_CHANGED': ' nodes changed',
  'history.CONNECTIONS_CHANGED': ' connections changed',
  'history.METADATA_UPDATES': ' metadata updates',
  'history.GRAPH_INFO_UPDATES': '📝 Graph Information Updates',
  'history.LAST_MODIFIED': 'Last Modified',
  'history.COMPONENT_CHANGES': '🔧 Component Changes',
  'history.WORKFLOW_CONNECTIONS': '🔗 Workflow Connections',
  'history.NO_DIFFERENCES': 'No differences found between versions',
  'history.BADGE_ADDED': 'Added',
  'history.BADGE_UPDATED': 'Updated',
  'history.NEW_COMPONENT_ADDED': 'New {type} added to the graph',
  'history.CONFIG_UPDATED': 'Configuration has been updated',
  'history.CONNECTION_UPDATED': 'Connection Updated',
  'history.FROM': 'From:',
  'history.TO': 'To:',
  'history.CONDITION': 'Condition:',
  'history.NEW_CONNECTION': 'New workflow connection established',
  // Change Pill Constants
  'history.CHIP_ADDED': 'ADDED',
  'history.CHIP_MODIFIED': 'MODIFIED',
  'history.CHIP_DELETED': 'DELETED',
  // Version Dropdown Constants
  'versionDropdown.SEARCH_PLACEHOLDER': 'Search...',
  // Publish Response Messages
  'publishResponse.GRAPH_PUBLISHED': 'Graph published',
  'publishResponse.NEW_VERSION_CREATED': 'New version created',
  'publishResponse.GRAPH_PUBLISHED_SUCCESSFULLY': 'Graph published successfully',
  'publishResponse.NEW_VERSION_CREATED_SUCCESSFULLY': 'New version created successfully',
  'publishResponse.SUCCESSFULLY_TO': 'successfully to',
  'publishResponse.AND': 'and',
  'publishResponse.TO': 'to',
  'publishResponse.BUT_FAILED_TO': 'but failed to',
  'publishResponse.CREATE_ON': 'create on',
  'publishResponse.PUBLISH_TO': 'publish to',
  'publishResponse.REASON': 'Reason',
  'publishResponse.ENV': 'env',
  'publishResponse.CURRENT': 'Current',
  'publishResponse.TARGET': 'Target',
  'publishResponse.IN': 'in',
  'publishResponse.TENANT': 'Tenant',
  'publishResponse.COPIED_TO': 'Copied to',
  'publishResponse.COPY_ON': 'copy on',

  'copyGraph.GRAPH_COPIED_SUCCESSFULLY': 'Graph copied successfully. Evaluations were not copied.',
  'copyGraph.TO': 'to',

  'editNodeModal.ADD_MCP_SERVER_CONFIG': 'Add MCP Server Config',
  'editNodeModal.ADD_NEW_MCP_SERVER': 'Add New MCP Server',
  'editNodeModal.SERVER_NAME': 'Server Name',
  'editNodeModal.MCP_SERVER_URL': 'Server Url',
  'editNodeModal.MCP_AUTH_TYPE': 'Auth Type',
  'editNodeModal.SELECT_AUTH_TYPE': 'Select Auth Type',
  'editNodeModal.IS_MCP_SERVER': 'Is Internal MCP Server',
  'editNodeModal.SELECT_MCP_SERVER': 'Select MCP Server',
  'editNodeModal.LABEL_MCP_AGENT_INTEGRATION': 'MCP agent integration',
  'editNodeModal.LABEL_MCP_SERVER': 'MCP server',
  'editNodeModal.LABEL_MCP_SERVER_CONFIGURATIONS': 'MCP configurations',
  'editNodeModal.BUTTON_LABEL_TEST_CONNECTION': 'Test Connection',
  'editNodeModal.BUTTON_LABEL_TESTING_CONNECTION': 'Testing...',
  'editNodeModal.BUTTON_LABEL_TEST_SUCCESSFUL': 'Test Successful',
  'editNodeModal.BUTTON_LABEL_RESUME_TEST_CONNECTION': 'Resume test',
  'editNodeModal.BUTTON_LABEL_AUTHENTICATING': 'Authenticating...',
  'editNodeModal.MCP_TEST_CONNECTION_SUCCESS': 'MCP server test connection successful',
  'editNodeModal.MCP_TEST_CONNECTION_FAILURE': 'Failed to test MCP server connection',
  'editNodeModal.MCP_VALIDATE_FAILURE': 'Failed to validate MCP server configuration',
  'editNodeModal.MCP_OAUTH_POPUP_BLOCKED': 'Unable to open OAuth window. Please allow popups and try again.',
  'editNodeModal.MCP_OAUTH_NO_TOOLS': 'OAuth completed but no tools were returned.',
  'editNodeModal.MCP_OAUTH_INVALID_REDIRECT': 'OAuth redirect URL is invalid or not allowed.',
  'editNodeModal.MCP_CONFIG_CREATE_SUCCESS': 'MCP server configuration created successfully',
  'editNodeModal.MCP_CONFIG_CREATE_FAILURE': 'Failed to create MCP server configuration',
  'editNodeModal.MCP_CONFIG_FETCH_FAILURE': 'Failed to get MCP server configurations',
  'editNodeModal.MCP_OAUTH_COMPLETE_IN_POPUP':
    'Complete authentication in the popup window. If you do not see it, allow popups for this site and try again.',
  'editNodeModal.LABEL_AVAILABLE_TOOLS': 'Available tools',
  'editNodeModal.LABEL_SELECT_GRAPH': 'Select Graph',
  'editNodeModal.SEARCH_GRAPH_PLACEHOLDER': 'Search graphs by name or Id...',
  'editNodeModal.SELECT_VERSION_PLACEHOLDER': 'Select Version...',
  'editNodeModal.NO_VERSIONS_FOUND': 'No versions found for this graph.',
  'editNodeModal.LABEL_SELECT_VERSION': 'Select Version',

  // Trends count report
  'trendsCount.DATE_RANGE': 'Date Range:',
  'trendsCount.TOTAL_COUNT': 'Total Count:',
  'trendsCount.TOTAL_ROW_LABEL': 'Total',
  'trendsCount.CSV_DATE_RANGE_SUMMARY': 'Date Range: {startDate} - {endDate} | Total Count: {grandTotal}',
  'trendsCount.FEATURE_USAGE_TITLE': 'Usage by Feature',
  'trendsCount.FEATURE_USAGE_FOR_IDENTIFIER': 'Usage by Feature — {identifierTitle}',
  'trendsCount.TOP_IDENTIFIERS_TITLE': 'Top {count} {entityLabelTitle} by Total Usage',
  'trendsCount.CHART_COUNT_AXIS': 'Count',
  'trendsCount.CHART_TOTAL_AXIS': 'Total Usage',
  'trendsCount.SORTED_BY_FEATURE': 'Chart filtered by: {feature}',
  'trendsCount.IDENTIFIER_DETAIL_TABLE': '{entityLabelSingularTitle}-wise Detail',
  'trendsCount.VIEW_GRAPH': 'View graphs',
  'trendsCount.VIEW_TABLE': 'View table',
  'trendsCount.SINGLE_IDENTIFIER_TABLE_HINT': '1 {entityLabelSingularTitle} selected',
  'trendsCount.VIEWING_IDENTIFIER': 'Chart scoped to: {identifierTitle}',
  'trendsCount.KPI_SECTION_TITLE': 'Key Metrics',
  'trendsCount.KPI_SHARE_LABEL': '{share}% of total',
  'trendsCount.SCOPE_LABEL': 'Scope',
  'trendsCount.SUMMARY_IDENTIFIERS_COUNT': '{count} {entityLabelTitle}',
  'trendsCount.EXPORT': 'Export',
  'trendsCount.TREND_LINE_TITLE': 'Usage Trend Over Time',
  'trendsCount.TREND_LINE_TITLE_IDENTIFIER': 'Usage Trend — {identifierTitle}',
  'trendsCount.TREND_LINE_DATE_AXIS': 'Date',
  'trendsCount.TREND_LINE_COUNT_AXIS': 'Count',
  'trendsCount.TREND_LINE_WINDOW_LABEL': 'Trend period',
  'trendsCount.TREND_LINE_WINDOW_7D': '7 days',
  'trendsCount.TREND_LINE_WINDOW_30D': '30 days',
  'trendsCount.TREND_LINE_WINDOW_FULL': 'Full range',
  'trendsCount.TREND_LINE_CUMULATIVE_COUNT_AXIS': 'Total Count',
  'trendsCount.TREND_LINE_SERIES_LABEL': 'Metrics',
  'trendsCount.TREND_LINE_SERIES_USAGE': 'Usage',
  'trendsCount.TREND_LINE_SERIES_FEEDBACK': 'Feedback',
  'trendsCount.TREND_LINE_COUNT_MODE_LABEL': 'View',
  'trendsCount.TREND_LINE_COUNT_MODE_CUMULATIVE': 'Cumulative',
  'trendsCount.TREND_LINE_COUNT_MODE_INDIVIDUAL': 'Separate',
  'trendsCount.FEATURE_OTHER_METRICS_TITLE': 'Other Metrics',
  'trendsCount.FEATURE_OTHER_METRICS_FOR_IDENTIFIER': 'Other Metrics — {identifierTitle}',

  // OTEL (Agent SDK) Count report — features are agent names rather than fixed count columns
  'otelTrendsCount.USAGE_BY_AGENT_TITLE': 'Usage by Agent',
  'otelTrendsCount.USAGE_BY_AGENT_FOR_IDENTIFIER': 'Usage by Agent — {identifierTitle}',
  'otelTrendsCount.TOP_IDENTIFIERS_TITLE': 'Top {count} {entityLabelTitle} by Total Traces',
  'otelTrendsCount.TREND_LINE_TITLE': 'Usage Trend Over Time',
  'otelTrendsCount.KPI_SHARE_LABEL': '{share}% of agent spans',
  'otelTrendsCount.SUMMARY_SCOPE': '{identifierCount} {entityLabelTitle} · {agentCount} Agents',
  'otelTrendsCount.AGENT_DETAIL_TABLE': 'Agent usage by {entityLabelSingularTitle}',

  // Custom table row actions (e.g., Users grid)
  'customTable.DELETE_USER': 'Delete user',
  'customTable.EDIT_USER': 'Edit user',
  'customTable.HISTORY': 'History',

  // Content Drawer (Studio — uploaded content list)
  'contentDrawer.TITLE': 'Uploaded Content',
  'contentDrawer.INSERT': 'Insert',
  'contentDrawer.REMOVE': 'Remove',
  'contentDrawer.NO_CONTENT': 'No content uploaded yet.',
  'contentDrawer.UPLOAD_FIRST_HINT': 'Use "Upload content" to add files.',
  'contentDrawer.CONFIRM_REMOVE_TITLE': 'Remove Content',
  'contentDrawer.CONFIRM_REMOVE_MESSAGE': 'Are you sure you want to remove this content? This action cannot be undone.',
  'contentDrawer.REFRESH_TOOLTIP': 'Refresh',
  'contentDrawer.STATUS_READY': 'Ready',
  'contentDrawer.STATUS_PROCESSING': 'Processing',
  'contentDrawer.STATUS_FAILED': 'Failed',
  'contentDrawer.UNKNOWN_STATUS': 'Unknown',
  'contentDrawer.PREVIEW_NOT_AVAILABLE': 'Preview not available',
  'contentDrawer.ADD_TO_GRAPH_TOOLTIP': 'Add to Graph',
  'contentDrawer.CONTENT_NOT_READY_TOOLTIP': 'Content not ready',
  'contentDrawer.PROCESSING_PREVIEW': 'Processing content...',
  'contentDrawer.LOADING_CONTENT': 'Loading content...',

  // Content Upload modal
  'contentUpload.MODAL_TITLE': 'Upload File',
  'contentUpload.DROP_ZONE_TEXT': 'Drag and drop your file here',
  'contentUpload.DROP_ZONE_OR': 'or',
  'contentUpload.BROWSE_FILES': 'Browse Files',
  'contentUpload.ACCEPTED_FORMATS': 'Accepted formats: .txt, .md',
  'contentUpload.CANCEL': 'Cancel',
  'contentUpload.INSERT_CONTENT': 'Insert Content',
  'contentUpload.TRUNCATED_HINT': '... Content truncated. Full file will be used when inserted.',
  'contentUpload.ERROR_INVALID_FILE_TYPE': 'Invalid file type. Only .txt and .md files are accepted.',
  'contentUpload.ERROR_READING_FILE': 'Error reading file. Please try again.',
  'contentUpload.UPLOADING': 'Uploading...'
};

export default en;
